import { apiGet, apiPost, cancellalableApiGet } from '../../api/api-configuration';
import {
  API_GET_SSM_CUSTOMER_DATA_ENDPOINT,
  API_POST_SSM_CUSTOMER_DATA_ENDPOINT,
  API_INITIATE_GET_SSM_CUSTOMER_DATA,
  API_COMPLETE_GET_SSM_CUSTOMER_DATA,
  API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA,
  API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA,
  ADDRESS_SEARCH_ENDPOINT,
  ADDRESS_DETAIL_ENDPOINT,
  SITE_CONTACT_FIRST_NAME,
  SITE_CONTACT_LAST_NAME,
  SITE_CONTACT_EMAIL,
  RADIO_BUTTON_CONFIRM_ID,
  SITE_CONTACT_PHONE,
  PORT_TYPE_ANALOG,
  SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
  SERVICE_TERM_DEVICE_TYPE_HANDSETS,
  SERVICE_TERM_DEVICE_TYPE_HEADSET,
  SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES,
  SERVICE_TERM_DEVICE_TYPE_POWERPACKS,
  SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
  PAYMENT_TYPE_MONTHLY,
  PAYMENT_TYPE_ONEOFF,
  SERVICE_TERM_PURCHASE_RADIO_BUTTON,
  ORDER_REVIEW_STATUS,
  ORDER_PARTIALLY_SAVED_STATUS,
  ORDER_READY_FOR_SUBMISSION_STATUS,
  ORDER_SUBMITTED_STATUS,
  ISDN_GOTOOPTION_MIGRATE_ALL_TIPT,
  SERVICE_TERM_ADDITIONAL_INFO,
  PORT_TYPE_P_PHONE,
  ISDN_GOTOOPTION_MIGRATE_ALL_BSIP,
  BSIP_CALLING_PLAN_SMALL,
  BSIP_SERVICE_TERM_DEFAULT_CONTRACT_TERM,
  BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
  PORT_TYPE_MOBILE,
  API_INITIATE_AUTO_SAVE,
  API_COMPLETE_AUTO_SAVE,
  API_POST_AUTO_SAVE_ENDPOINT,
  ISDN_CALLBACK_REQUEST_ENDPOINT,
  INITIATE_ISDN_CALLBACK_REQUEST,
  COMPLETE_ISDN_CALLBACK_REQUEST,
  ISDN_GOTOOPTION_REDIRECT_OR_CANCEL,
  SITE_STATUS_SUBMITTED,
  SIP_CONNECT_NO_PABX,
  SIP_CONNECT_PABX_NOT_LISTED,
  SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION,
  SIP_CONNECT_PABX_MODEL_NOT_LISTED,
  IAD_DEVICE_425,
  IAD_DEVICE_270,
  IAD_DEVICE_700,
  IAD_DEVICE_NOT_REQUIRED,
  SIP_CALLING_PLAN_SELECT_OPTION,
  BUSINESS_LINE,
  BUSINESS_TRUNK,
  BUSINESS_CONTINUITY,
  MOBILITY_CONTINUITY,
  ONE_425,
  ONE_270,
  ONE_700,
  ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT,
  SIP_CONNECT_SERVICE_TERM_DEFAULT_CONTRACT_TERM,
  MIGRATE_TO_ENTERPRISE_TRUNK,
  REQUEST_CALL_BACK,
  ISDN_GOTOOPTION_YET_TO_FILL_IN_DETAILS,
} from '../../app-constants';

import { failureAction, getAuthorizationAccessToken } from '../../app-actions';


export const successActionSSMCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_GET_SSM_CUSTOMER_DATA, data };
};

export const getSSMCustomerData = data => (dispatch) => {
  const endpoint = `${API_GET_SSM_CUSTOMER_DATA_ENDPOINT}&value=${encodeURIComponent(window.parent.tcom.researchInsights.appConfig.currentAccount)}`;
  dispatch({ type: API_INITIATE_GET_SSM_CUSTOMER_DATA });
  apiGet(dispatch, endpoint, successActionSSMCustomerData, failureAction, data);
};

export const successActionSubmitSSMCustomerData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_SUBMIT_SSM_SITE_CUSTOMER_DATA, data };
};


export const submitSSMCustomerData = data => (dispatch) => {
  const endpoint = API_POST_SSM_CUSTOMER_DATA_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: API_INITIATE_SUBMIT_SSM_CUSTOMER_DATA });
  apiPost(dispatch, endpoint, successActionSubmitSSMCustomerData, failureAction, dataWithEncryptedCidn);
};

export const successActionAutoSaveData = (response) => {
  const { data } = response;
  return { type: API_COMPLETE_AUTO_SAVE, data };
};


export const submitAutoSaveData = data => (dispatch) => {
  const endpoint = API_POST_AUTO_SAVE_ENDPOINT;
  const bearerToken = getAuthorizationAccessToken();
  if (bearerToken !== 'Bearer undefined') {
    const dataWithEncryptedCidn = {
      ...data,
      value: window.parent.tcom.researchInsights.appConfig.currentAccount,
    };
    dispatch({ type: API_INITIATE_AUTO_SAVE });
    apiPost(dispatch, endpoint, successActionAutoSaveData, failureAction, dataWithEncryptedCidn);
  } else {
    dispatch({ type: '' });
  }
};


export const stripStartingAndEndingPTags = (htmlText) => {
  const trimmedHtmlText = htmlText.trim();
  const htmlTextWithoutStartingAndEndingPTags = trimmedHtmlText.substr(3, trimmedHtmlText.length - 4);
  return htmlTextWithoutStartingAndEndingPTags;
};

export const prepareContactSitesDataOnApplicationLoad = sitesData => (sitesData.map(siteData => (
  {
    siteId: siteData.siteId,
    isSiteProcessed: false,
    [SITE_CONTACT_FIRST_NAME]: siteData.siteContactFirstName,
    [SITE_CONTACT_LAST_NAME]: siteData.siteContactLastName,
    [SITE_CONTACT_EMAIL]: siteData.siteContactEmail,
    [SITE_CONTACT_PHONE]: siteData.siteContactPhone,
  }))
);

/*
  This stores two values per input
  - invalid: the user has entered invalid input
  - touched: the user has touched the input

  This lets us treat untouched inputs as invalid for form progression,
  while not showing error messages on them until the user edits them or
  attempts to progress the form.
*/
export const prepareErrorMessageDataForContactSiteOnApplicatioLoad = sitesData => (sitesData.map(siteData => (
  {
    siteId: siteData.siteId,
    [SITE_CONTACT_FIRST_NAME]: { invalid: false, touched: false },
    [SITE_CONTACT_LAST_NAME]: { invalid: false, touched: false },
    [SITE_CONTACT_EMAIL]: { invalid: false, touched: false },
    [SITE_CONTACT_PHONE]: { invalid: false, touched: false },
  }))
);

export const validateEmail = (email) => {
  const regex = /^([a-zA-Z0-9_-]+)(.[a-zA-Z0-9_-]+)*@[a-zA-Z0-9_-]+(.[a-zA-Z0-9_-]+)*.([a-zA-Z]{2,})/;
  return regex.test(email);
};

export const validateABNOrACN = (abnOrAcn) => {
  const regex = /^(?=(?:.{9}|.{11})$)[0-9]*$/;
  return regex.test(abnOrAcn);
};

export const validateText = (text) => {
  const textWithoutSpaces = text.replace(/[\s]/g, '');
  const regex = /^([a-zA-Z'-]+)$/;
  return regex.test(textWithoutSpaces);
};

export const validatePhoneNumber = (phoneNumber) => {
  const phoneNumberWithoutSpaces = phoneNumber.replace(/[\s]/g, '');
  const regex = /^[0-9]{10}$/;
  return regex.test(phoneNumberWithoutSpaces);
};

export const validateNumber = (number) => {
  const regex = /^\d*$/;
  return regex.test(number);
};

export const validateAccountOrBillNumber = (accountNumber) => {
  if (accountNumber.length > 0) {
    return validateNumber(accountNumber) && accountNumber.length <= 12;
  }
  return true;
};

export const validateTextAndNumbers = (text) => {
  const textWithoutSpaces = text.replace(/[\s]/g, '');
  const regex = /^([a-zA-Z0-9-?]+)$/;
  return regex.test(textWithoutSpaces);
};

export const validateContactSiteFormFields = (id, value) => {
  if (value && value.length > 0) {
    if (id.toString() === SITE_CONTACT_FIRST_NAME || id.toString() === SITE_CONTACT_LAST_NAME) {
      return !validateText(value);
    } else if (id.toString() === SITE_CONTACT_EMAIL) {
      return !validateEmail(value);
    }
    return !validatePhoneNumber(value);
  }
  return true;
};

export const validatePostCode = (postCode) => {
  const regex = /^[0-9]{4}$/;
  return regex.test(postCode);
};

export const prepareConfirmOrderDataOnApplicationLoad = (sitesData) => {
  let confirmOrderData = [];
  sitesData.forEach((siteData) => {
    const { siteServices, siteId, virtualSite } = siteData;
    siteServices.forEach((siteService) => {
      const migrateRadioButton = [{ id: `migrate-${siteId}-${siteService.dn}`, checked: false }];
      confirmOrderData = [...confirmOrderData,
        ...(!virtualSite ? migrateRadioButton : []),
        {
          id: `redirect-${siteId}-${siteService.dn}`, checked: false,
        },
        {
          id: `cancel-${siteId}-${siteService.dn}`,
          checked: false,
        }];
    });
    const migrateAllRadioButton = [{
      id: `migrate-all-${siteId}`,
      checked: false }];
    confirmOrderData = [...confirmOrderData,
      ...(!virtualSite ? migrateAllRadioButton : []),
      {
        id: `redirect-all-${siteId}`,
        checked: false,
      },
      {
        id: `cancel-all-${siteId}`,
        checked: false,
      },
    ];
  });
  return confirmOrderData;
};

export const prepareServiceUsageDataOnApplicationLoad = (sitesData) => {
  let serviceUsageData = [];
  sitesData.forEach((siteData) => {
    if (!siteData.virtualSite) {
      siteData.siteServices.forEach((siteService) => {
        serviceUsageData = [...serviceUsageData, {
          id: `usage-${siteData.siteId}-${siteService.dn}`,
          usageValue: '',
        }];
      });
    }
  });
  return serviceUsageData;
};

export const prepareServiceUsageErrorDataOnApplicationLoad = (sitesData) => {
  let serviceUsageTypeFieldErrors = {};
  sitesData.forEach((siteData) => {
    if (!siteData.virtualSite) {
      siteData.siteServices.forEach((siteService) => {
        serviceUsageTypeFieldErrors = { ...serviceUsageTypeFieldErrors,
          [`usage-${siteData.siteId}-${siteService.dn}`]: false };
      });
    }
  });
  return serviceUsageTypeFieldErrors;
};

export const prepareSSMRedirectTypeOnApplicationLoad = (sitesData) => {
  let redirectTypeData = [];
  sitesData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      redirectTypeData = [...redirectTypeData, {
        id: `redirectType-${siteData.siteId}-${siteService.dn}`,
        redirectTypeValue: '',
      }];
    });
  });
  return redirectTypeData;
};

export const prepareSSMRedirectNumberDataOnApplicationLoad = (sitesData) => {
  let redirectNumberData = {};
  sitesData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      redirectNumberData = { ...redirectNumberData,
        [`redirectNumber-${siteData.siteId}-${siteService.dn}`]: siteService.redirectNumber };
    });
  });
  return redirectNumberData;
};

export const prepareSSMNameDisplayrDataOnApplicationLoad = (sitesData) => {
  let nameDisplayData = {};
  sitesData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      nameDisplayData = { ...nameDisplayData,
        [`nameDisplay-${siteData.siteId}-${siteService.dn}`]: siteService.nameDisplay };
    });
  });
  return nameDisplayData;
};


export const prepareSSMRedirectTypeDataOnApplicationLoad = (sitesData) => {
  let redirectTypeErrorData = {};
  sitesData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      redirectTypeErrorData = { ...redirectTypeErrorData,
        [`redirectType-${siteData.siteId}-${siteService.dn}`]: false };
    });
  });
  return redirectTypeErrorData;
};

export const validateDropDown = dropDownItem => dropDownItem.length > 0;

export const prepareSSMRedirectNumberErrorDataOnApplicationLoad = (sitesData) => {
  let redirectNumberErrorData = {};
  sitesData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      redirectNumberErrorData = { ...redirectNumberErrorData,
        [`redirectNumber-${siteData.siteId}-${siteService.dn}`]: false };
    });
  });
  return redirectNumberErrorData;
};

export const getUpdatedServiceUsageData = (serviceUsageData, selectedUsageObject) => {
  const newServiceUsageData = serviceUsageData.filter(usageItem => usageItem.id !== selectedUsageObject.id);

  newServiceUsageData.push({
    id: selectedUsageObject.id,
    usageValue: selectedUsageObject.value,
  });

  return newServiceUsageData;
};

export const getUpdatedRedirectTypeData = (redirectTypeData, selectedRedirectTypeObject) => {
  const newRedirectTypeData = redirectTypeData.filter(redirectTypeItem => redirectTypeItem.id !== selectedRedirectTypeObject.id);

  newRedirectTypeData.push({
    id: selectedRedirectTypeObject.id,
    redirectTypeValue: selectedRedirectTypeObject.value,
  });
  return newRedirectTypeData;
};


export const getRadioButtonIdWithOutButtonType = (radioButtonId) => {
  const siteId = radioButtonId.split('-')[1];
  const dn = radioButtonId.split('-')[2];
  return `${siteId}-${dn}`;
};

export const getButtonType = (buttonId) => {
  const buttonType = buttonId.split('-')[0];
  return buttonType;
};

export const getNewConfirmOrderForLineItemClick = (confirmOrderData, radioButtonId, sitesData) => {
  const migrateId = `migrate-${getRadioButtonIdWithOutButtonType(radioButtonId)}`;
  const cancelId = `cancel-${getRadioButtonIdWithOutButtonType(radioButtonId)}`;
  const redirectId = `redirect-${getRadioButtonIdWithOutButtonType(radioButtonId)}`;
  const siteId = radioButtonId.split('-')[1];
  const migrateAllId = `migrate-all-${siteId}`;
  const cancelAllId = `cancel-all-${siteId}`;
  const redirectAllId = `redirect-all-${siteId}`;
  const virtualSite = sitesData.filter(siteData => siteData.siteId === siteId)[0].virtualSite;

  const newConfirmOrderData = confirmOrderData.filter(orderItem => orderItem.id !== migrateId
      && orderItem.id !== cancelId
      && orderItem.id !== migrateAllId
      && orderItem.id !== cancelAllId
      && orderItem.id !== redirectId
      && orderItem.id !== redirectAllId);

  if (radioButtonId === migrateId) {
    newConfirmOrderData.push({ id: migrateId, checked: true });
    newConfirmOrderData.push({ id: cancelId, checked: false });
    newConfirmOrderData.push({ id: redirectId, checked: false });
  } else if (radioButtonId === redirectId) {
    newConfirmOrderData.push({ id: redirectId, checked: true });
    newConfirmOrderData.push({ id: cancelId, checked: false });
    if (!virtualSite) {
      newConfirmOrderData.push({ id: migrateId, checked: false });
    }
  } else {
    if (!virtualSite) {
      newConfirmOrderData.push({ id: migrateId, checked: false });
    }
    newConfirmOrderData.push({ id: redirectId, checked: false });
    newConfirmOrderData.push({ id: cancelId, checked: true });
  }
  if (!virtualSite) {
    newConfirmOrderData.push({ id: migrateAllId, checked: false });
  }
  newConfirmOrderData.push({ id: redirectAllId, checked: false });
  newConfirmOrderData.push({ id: cancelAllId, checked: false });

  return newConfirmOrderData;
};

export const getNewConfirmOrderForAllItemClick = (confirmOrderData, radioButtonId) => {
  const siteId = radioButtonId.split('-')[2];
  const migrateAllId = `migrate-all-${siteId}`;
  const redirectAllId = `redirect-all-${siteId}`;

  let newConfirmOrderData;

  if (radioButtonId === migrateAllId) {
    newConfirmOrderData = confirmOrderData.map((orderItem) => {
      if (orderItem.id.includes(siteId) && orderItem.id.includes('migrate')) {
        return { ...orderItem, checked: true };
      } else if (orderItem.id.includes(siteId) && (orderItem.id.includes('cancel') || orderItem.id.includes('redirect'))) {
        return { ...orderItem, checked: false };
      }
      return orderItem;
    });
  } else if (radioButtonId === redirectAllId) {
    newConfirmOrderData = confirmOrderData.map((orderItem) => {
      if (orderItem.id.includes(siteId) && orderItem.id.includes('redirect')) {
        return { ...orderItem, checked: true };
      } else if (orderItem.id.includes(siteId) && (orderItem.id.includes('cancel') || orderItem.id.includes('migrate'))) {
        return { ...orderItem, checked: false };
      }
      return orderItem;
    });
  } else {
    newConfirmOrderData = confirmOrderData.map((orderItem) => {
      if (orderItem.id.includes(siteId) && orderItem.id.includes('cancel')) {
        return { ...orderItem, checked: true };
      } else if (orderItem.id.includes(siteId) && (orderItem.id.includes('migrate') || orderItem.id.includes('redirect'))) {
        return { ...orderItem, checked: false };
      }
      return orderItem;
    });
  }
  return newConfirmOrderData;
};

export const getFullCombinedAddress = (siteData) => {
  const { siteLvlUnitNum, sitePropertyNum, siteStName, siteStType, siteSuburb, siteState, sitePostcode, virtualSite } = siteData;
  let completeAddress;
  if (virtualSite) {
    completeAddress = siteStName;
  } else {
    completeAddress = `${siteLvlUnitNum.length ? (`${siteLvlUnitNum} `) : ''}${sitePropertyNum}
    ${siteStName} ${siteStType} ${siteSuburb} ${siteState} ${sitePostcode}`;
  }
  return completeAddress;
};

export const prepareDeliveryAddressForSitesOnApplicationLoad = (sitesData) => {
  const deliveryAddressData = [];
  sitesData.forEach((siteData) => {
    deliveryAddressData.push({
      siteId: siteData.siteId,
      fullAddress: getFullCombinedAddress(siteData),
      modifiedDetailedAddresObject: {},
    });
  });
  return deliveryAddressData;
};

export const getUserSiteId = (deliveryAddressesData, siteId) => {
  const selectedDeliveryAddressData = deliveryAddressesData.filter(daliveryAddressData => daliveryAddressData.siteId === siteId)[0];
  const userSiteId = selectedDeliveryAddressData.modifiedDetailedAddresObject.addressId;
  return userSiteId !== undefined ? userSiteId : null;
};

export const contactSiteFieldsErrorValidaton = (contactSiteFieldsErrors) => {
  // this holds data of Contact Site Form Field Error Status
  let contactSiteFieldsErrorValidatonData = [];
  contactSiteFieldsErrors.forEach(contactSiteData => Object.values(contactSiteData)
    .forEach((value) => {
      if (typeof value === typeof true) {
        contactSiteFieldsErrorValidatonData = [...contactSiteFieldsErrorValidatonData, value];
      }
    }));
  return contactSiteFieldsErrorValidatonData;
};

export const validateRedirectionRadioButtonClick = (redirectType, redirectionNumber) => {
  const redirectionNumberValidation = validatePhoneNumber(redirectionNumber);
  const redirectionTypeValidation = redirectType.length > 0;
  return !(redirectionNumberValidation && redirectionTypeValidation);
};

export const confirmOrderDataAndUsageValidation = (sitesData, stateData, selectedSiteId) => {
  const { confirmOrderData, serviceUsageData, redirectTypeData, redirectNumberData } = stateData;
  // removing migrate all and cancel all for checking
  const confirmOrderDataWithOutMigrateAllRedirectAllAndCancelAll = confirmOrderData
    .filter(confirmOrderItemData => !confirmOrderItemData.id.includes('migrate-all') &&
        !confirmOrderItemData.id.includes('cancel-all') && !confirmOrderItemData.id.includes('redirect-all'));
  let confirmOrderDataAndUsageData = [];// this holds the migrate, cancel and usage object of every dn value
  const selectedSiteData = sitesData.filter(siteData => siteData.siteId === selectedSiteId);
  selectedSiteData.forEach((siteData) => {
    siteData.siteServices.forEach((siteService) => {
      const confirmOrderAndUsageServiceDetailItemData =
        [...confirmOrderDataWithOutMigrateAllRedirectAllAndCancelAll
          .filter(data => getRadioButtonIdWithOutButtonType(data.id) === `${siteData.siteId}-${siteService.dn}`),
        ...serviceUsageData.filter(data => getRadioButtonIdWithOutButtonType(data.id) === `${siteData.siteId}-${siteService.dn}`),
        ...redirectTypeData.filter(data => getRadioButtonIdWithOutButtonType(data.id) === `${siteData.siteId}-${siteService.dn}`)];
      let confirmOrderAndUsageServiceDetailObject = {}; // this object holds data of migrate, cancel and usage data with same dn value
      confirmOrderAndUsageServiceDetailItemData.forEach((data) => {
        confirmOrderAndUsageServiceDetailObject = {
          ...confirmOrderAndUsageServiceDetailObject,
          siteId: siteData.siteId,
          dn: siteService.dn,
          ...((data.checked !== undefined) ? { [data.id]: data.checked } : {}),
          ...((data.redirectTypeValue !== undefined) ? { [data.id]: data.redirectTypeValue } : {}),
          ...((data.usageValue !== undefined) ? { [data.id]: data.usageValue } : {}),
          ...((siteService.portType !== undefined) ? { portType: siteService.portType } : {}),
          [`redirectNumber-${siteData.siteId}-${siteService.dn}`]: redirectNumberData[`redirectNumber-${siteData.siteId}-${siteService.dn}`],
        };
      });
      confirmOrderDataAndUsageData = [...confirmOrderDataAndUsageData, confirmOrderAndUsageServiceDetailObject];
    });
  });
  let confirmOrderDataAndUsageValidationData = []; // holds the service section validation status
  let { redirectTypeFieldErrors, serviceUsageTypeFieldErrors, redirectNumberFieldErrors } = stateData;
  confirmOrderDataAndUsageData.forEach((dataItem) => {
    const migrateRadioOptionId = Object.keys(dataItem).filter(key => getButtonType(key) === 'migrate')[0];
    const migrateRadioOptionCheckedValue = migrateRadioOptionId !== undefined ? dataItem[migrateRadioOptionId] : false;
    const cancelRadioOptionId = Object.keys(dataItem).filter(key => getButtonType(key) === 'cancel')[0];
    const redirectRadioOptionId = Object.keys(dataItem).filter(key => getButtonType(key) === 'redirect')[0];
    const usageDropDownId = Object.keys(dataItem).filter(key => getButtonType(key) === 'usage')[0];
    const redirectTypeId = Object.keys(dataItem).filter(key => getButtonType(key) === 'redirectType')[0];
    const redirectNumberId = Object.keys(dataItem).filter(key => getButtonType(key) === 'redirectNumber')[0];
    // checking whether any of the radio button is clicked
    if (!(migrateRadioOptionCheckedValue || dataItem[cancelRadioOptionId] || dataItem[redirectRadioOptionId])) {
      confirmOrderDataAndUsageValidationData = [...confirmOrderDataAndUsageValidationData,
        { siteId: dataItem.siteId, dn: dataItem.dn, errorStatus: true }];
      // checking if migrate radio button clicked and the usage value selected
    } else if ((usageDropDownId && usageDropDownId.length > 0 && dataItem.portType && dataItem.portType.toUpperCase() === PORT_TYPE_ANALOG)
        && migrateRadioOptionCheckedValue) {
      serviceUsageTypeFieldErrors = { ...serviceUsageTypeFieldErrors, [usageDropDownId]: !validateDropDown(dataItem[usageDropDownId]) };
      confirmOrderDataAndUsageValidationData = [...confirmOrderDataAndUsageValidationData,
        { siteId: dataItem.siteId, dn: dataItem.dn, errorStatus: !(dataItem[usageDropDownId]).length > 0 }];
    } else if (dataItem[redirectRadioOptionId]) {
      redirectTypeFieldErrors = { ...redirectTypeFieldErrors, [redirectTypeId]: !validateDropDown(dataItem[redirectTypeId]) };
      redirectNumberFieldErrors = { ...redirectNumberFieldErrors, [redirectNumberId]: !validateDropDown(dataItem[redirectNumberId]) };
      confirmOrderDataAndUsageValidationData = [...confirmOrderDataAndUsageValidationData,
        {
          siteId: dataItem.siteId,
          dn: dataItem.dn,
          errorStatus: validateRedirectionRadioButtonClick(dataItem[redirectTypeId], dataItem[redirectNumberId]) }];
    } else {
      // checking if the cancel button is selected
      confirmOrderDataAndUsageValidationData = [...confirmOrderDataAndUsageValidationData,
        { siteId: dataItem.siteId, dn: dataItem.dn, errorStatus: false }];
    }
  });
  return { confirmOrderDataAndUsageValidationData, redirectTypeFieldErrors, serviceUsageTypeFieldErrors, redirectNumberFieldErrors };
};

export const getAddressSearchResult = data => (cancellalableApiGet(ADDRESS_SEARCH_ENDPOINT, data));

export const getAddressDetails = data => (cancellalableApiGet(ADDRESS_DETAIL_ENDPOINT, data));

export const getSuggestedAddressList = (data) => {
  const suggestedAddressessList = [];

  data.forEach((suggestedData) => {
    suggestedAddressessList.push({
      key: suggestedData.addressId,
      value: `${suggestedData.streetNumber} ${suggestedData.streetName} ${suggestedData.suburb}`,
      detailedAddressObject: suggestedData,
    });
  });
  return suggestedAddressessList;
};

export const getUpdatedDeliveryAddressData = (selectedAddressObject, deliveryAddressData, siteId) => {
  const addressObject = selectedAddressObject[0];
  let newDeliveryAddressData = deliveryAddressData.filter(address => address.siteId !== siteId);
  newDeliveryAddressData = [...newDeliveryAddressData, {
    siteId,
    fullAddress: `${addressObject.streetNumber} ${addressObject.streetName} ${addressObject.suburb}`,
    modifiedDetailedAddresObject: addressObject,
  }];

  return newDeliveryAddressData;
};

export const getPortTypeValue = (radioButtonClicked, sitesData) => {
  let portType = '';
  if (!radioButtonClicked.id.includes('all')) {
    const [, siteId, dn] = radioButtonClicked.id.split('-');
    const siteDataWithRadioButtonSiteId = sitesData.filter(siteData => siteData.siteId === siteId)[0];
    portType = siteDataWithRadioButtonSiteId.siteServices.filter(siteService => siteService.dn === dn)[0].portType;
  }
  return portType;
};

export const getUpdatedDeliveryAddressDataUsingSuggestedAddresses = (addressId, suggestedAddressList, deliveryAddressData, siteId) => {
  const addressObject = suggestedAddressList.filter(address => address.key === addressId)[0];
  let newDeliveryAddressData = deliveryAddressData.filter(address => address.siteId !== siteId);
  newDeliveryAddressData = [...newDeliveryAddressData, {
    siteId,
    fullAddress: addressObject.value,
    modifiedDetailedAddresObject: addressObject.detailedAddressObject,
  }];

  return newDeliveryAddressData;
};
export const escapeHTML = htmlText => (htmlText.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'));

export const checkUserChangedFormFields = (userFormFieldsDataForSubmission, formFieldToCheck) => {
  if (validateContactSiteFormFields(formFieldToCheck, userFormFieldsDataForSubmission[formFieldToCheck])) {
    return null;
  }
  return escapeHTML(userFormFieldsDataForSubmission[formFieldToCheck]);
};

export const checkUserChangedDetails = (siteData, userFormFieldsDataForSubmission, deliveryAddressesData) => {
  let userChangedDetails = [];
  const userFormFieldsDataForSubmissionKeys = Object.keys(userFormFieldsDataForSubmission);
  userFormFieldsDataForSubmissionKeys.forEach((key) => {
    if (siteData[key] === userFormFieldsDataForSubmission[key]) {
      userChangedDetails = [...userChangedDetails, false];
    } else {
      userChangedDetails = [...userChangedDetails, true];
    }
  });
  const deliveryAddressDataModified = getUserSiteId(deliveryAddressesData, siteData.siteId) === null;
  if (deliveryAddressDataModified) {
    userChangedDetails = [...userChangedDetails, false];
  } else {
    userChangedDetails = [...userChangedDetails, true];
  }
  return !userChangedDetails.every(value => !value);
};

export const prepareSSMSubmitCustomerData = (sitesData, stateData) => {
  let ssmCustomerSitesData = []; // this holds complete SSM Customer Data
  const confirmChangesChecked = stateData.confirmChangesOptions.radioButtons
    .filter(radioButton => radioButton.id === RADIO_BUTTON_CONFIRM_ID)[0].checked;
  sitesData.forEach((siteData) => {
    let siteServices = []; // this holds the siteServices data for each siteId
    siteData.siteServices.forEach((siteService) => {
      const siteServiceUsage = stateData.serviceUsageData.filter(serviceUsage => serviceUsage.id === `usage-${siteData.siteId}-${siteService.dn}`)[0];
      const siteServiceUsageValue = siteServiceUsage && siteServiceUsage.usageValue &&
        siteServiceUsage.usageValue.length > 0 ? siteServiceUsage.usageValue : null;
      const redirectNumberValue = stateData.redirectNumberData[`redirectNumber-${siteData.siteId}-${siteService.dn}`];
      const nameDisplayValue = stateData.nameDisplayData[`nameDisplay-${siteData.siteId}-${siteService.dn}`];
      const redirectNumberType = stateData.redirectTypeData
        .filter(redirectType => redirectType.id === `redirectType-${siteData.siteId}-${siteService.dn}`)[0];
      const redirectTypeValue = redirectNumberType.redirectTypeValue.length > 0 ? redirectNumberType.redirectTypeValue : null;
      const migrateObject = stateData.confirmOrderData
        .filter(confirmOrderDataItem => confirmOrderDataItem.id === `migrate-${siteData.siteId}-${siteService.dn}`)[0];
      const cancelObject = stateData.confirmOrderData
        .filter(confirmOrderDataItem => confirmOrderDataItem.id === `cancel-${siteData.siteId}-${siteService.dn}`)[0];
      const redirectObject = stateData.confirmOrderData
        .filter(confirmOrderDataItem => confirmOrderDataItem.id === `redirect-${siteData.siteId}-${siteService.dn}`)[0];
      const siteServiceItem = {
        nameDisplay: nameDisplayValue,
        dn: siteService.dn,
        portType: siteService.portType,
        portTypeUse: siteServiceUsageValue,
        migrate: migrateObject && migrateObject.checked ? migrateObject.checked : false,
        cancel: cancelObject.checked,
        redirect: redirectObject.checked,
        redirectType: redirectTypeValue,
        redirectNumber: redirectNumberValue.length > 0 ? redirectNumberValue : null,
      };
      siteServices = [...siteServices, siteServiceItem];
    });
    const userFormFieldsDataForSubmission = stateData.formFields.filter(formField => formField.siteId === siteData.siteId)[0];
    const siteDelieveryAddressData = stateData.deliveryAddressesData
      .filter(address => address.siteId === siteData.siteId)[0].modifiedDetailedAddresObject.fullAddress;
    const usrSiteId = getUserSiteId(stateData.deliveryAddressesData, siteData.siteId);
    const ssmCustomerDataItem = {
      siteId: siteData.siteId,
      usrSiteId,
      usrChangedDetails: checkUserChangedDetails(siteData, userFormFieldsDataForSubmission, stateData.deliveryAddressesData),
      usrLvlUnitNum: usrSiteId ? null : siteData.siteLvlUnitNum,
      usrPropertyNum: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails.propertyNumberFrom : siteData.sitePropertyNum,
      usrStName: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails.streetDetails.streetName : siteData.siteStName,
      usrStType: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails.streetDetails.streetType : siteData.siteStType,
      usrSuburb: usrSiteId ? siteDelieveryAddressData.localityDetails.locality : siteData.siteSuburb,
      usrState: usrSiteId ? siteDelieveryAddressData.localityDetails.state : siteData.siteState,
      usrPostcode: usrSiteId ? siteDelieveryAddressData.localityDetails.postCode : siteData.sitePostcode,
      usrAddSiteNotes: null,
      usrSiteContactFirstName: checkUserChangedFormFields(siteData, userFormFieldsDataForSubmission, SITE_CONTACT_FIRST_NAME),
      usrSiteContactLastName: checkUserChangedFormFields(siteData, userFormFieldsDataForSubmission, SITE_CONTACT_LAST_NAME),
      usrSiteContactEmail: checkUserChangedFormFields(siteData, userFormFieldsDataForSubmission, SITE_CONTACT_EMAIL),
      usrSiteContactPhone: checkUserChangedFormFields(siteData, userFormFieldsDataForSubmission, SITE_CONTACT_PHONE),
      siteServices,
    };
    ssmCustomerSitesData = [...ssmCustomerSitesData, ssmCustomerDataItem];
  });
  const ssmCustomerData = {
    confirmChanges: confirmChangesChecked,
    sitesData: ssmCustomerSitesData,
  };
  return ssmCustomerData;
};

export const validateSiteContactFormFieldsOnSubmit = (formFields) => {
  let validateStatus = true;
  formFields.forEach((formField) => {
    Object.keys(formField).forEach((field) => {
      if ((field !== 'siteId' && field !== 'isSiteProcessed' && field !== 'info') && validateContactSiteFormFields(field, formField[field])) {
        validateStatus = false;
      }
      return validateStatus;
    });
  });
  return validateStatus;
};

export const scrollElementIntoView = (elementId) => {
  const element = document.getElementById(elementId);
  if (element) {
    // const parentElement = element.parentElement;
    // parentElement.scrollIntoView();
    element.scrollIntoView();
  }
};

// This allows scrolling to an element with a class, or using more complex query selectors
export const scrollFirstMatchingElementIntoView = (query) => {
  const element = document.querySelector(query);
  if (element) {
    const parentElement = element.parentElement;
    parentElement.scrollIntoView();
  }
};

export const scrollMatchingElementIntoView = (query) => {
  const element = document.querySelector(query);
  if (element) {
    element.scrollIntoView();
  }
};


export const isMigrateOptionSelectedForSite = (siteId, migrateOptionsData) => {
  let migrateOptionSelected = false;
  migrateOptionsData.forEach((optionData) => {
    if (optionData.id.includes(`migrate-${siteId}`) && optionData.checked) {
      migrateOptionSelected = true;
    }
    return migrateOptionSelected;
  });
  return migrateOptionSelected;
};

export const prepareServiceTermDevicesQuantityDataForSitesOnApplicationLoad = (sitesData, authorableData) => {
  const serviceTermDevicesQuantity = [];
  const { handsets, powerPacks, headset, integratedAccessDevices, featuresPacks, callCenter } = authorableData;
  sitesData.forEach((siteData) => {
    featuresPacks.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
    handsets.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_HANDSETS}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
    powerPacks.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_POWERPACKS}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
    headset.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_HEADSET}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
    integratedAccessDevices.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
    callCenter.items.forEach((item) => {
      serviceTermDevicesQuantity.push({
        id: `${SERVICE_TERM_DEVICE_TYPE_CALLCENTER}-${item.itemName}-${siteData.siteId}-quantity`,
        quantity: '',
      });
    });
  });
  return serviceTermDevicesQuantity;
};

export const prepareServiceTermConnectionDateForSitesOnApplicationLoad = (sitesData) => {
  const serviceTermConnectionDateData = [];
  sitesData.forEach((siteData) => {
    serviceTermConnectionDateData.push({
      siteId: siteData.siteId,
      connectionDate: null,
      purchaseRentalSelectedOption: SERVICE_TERM_PURCHASE_RADIO_BUTTON,
    });
  });
  return serviceTermConnectionDateData;
};

export const getSiteStatusForDisplay = (siteStatus, orderReviewStatusText, partiallySavedText, readyForSubmissionText, submittedText) => {
  switch (siteStatus) {
    case ORDER_REVIEW_STATUS:
      return orderReviewStatusText;
    case ORDER_PARTIALLY_SAVED_STATUS:
    case ORDER_READY_FOR_SUBMISSION_STATUS:
      return readyForSubmissionText;
    case ORDER_SUBMITTED_STATUS:
      return submittedText;
    default:
      return orderReviewStatusText;
  }
};


export const prepareOrderSummaryDataForSitesOnApplicationLoad = (sitesData) => {
  const orderSummaryData = [];
  sitesData.forEach((siteData, index) => {
    orderSummaryData.push({
      siteId: siteData.siteId,
      siteStatus: ORDER_REVIEW_STATUS,
      siteAddress: getFullCombinedAddress(siteData),
      migratedServicesCount: 0,
      cancelledServicesCount: 0,
      redirectedServicesCount: 0,
      monthlyCost: 0.0,
      onceOffCost: 0.0,
      sitePosition: index + 1,
    });
  });
  return orderSummaryData;
};

export const getSiteStatus = (siteContactValidateStatus, confirmOrderDataAndUsageValidationData, isSiteProcessed, totalServiceSelectionCount) => {
  let newSiteStatus = ORDER_REVIEW_STATUS;

  const isServiceTableSelectionValid = confirmOrderDataAndUsageValidationData.every(dataItem => dataItem.errorStatus === false);
  if (siteContactValidateStatus && isServiceTableSelectionValid) {
    newSiteStatus = ORDER_READY_FOR_SUBMISSION_STATUS;
  } else if (isSiteProcessed || totalServiceSelectionCount > 0) {
    newSiteStatus = ORDER_PARTIALLY_SAVED_STATUS;
  }
  return newSiteStatus;
};

export const updateOrderSummaryAfterServiceTableChanges = (serviceTermAuthorable, sitesData, stateData) => {
  const
    {
      orderSummaryData,
      confirmOrderData,
      serviceTermSelectedOption,
      selectedSiteId,
      serviceTermDeviceQuantityData: deviceQuantityData,
      formFields: siteContactDetails,
    } = stateData;

  let siteOrderDataToBeChanged = orderSummaryData.filter((orderItem => orderItem.siteId === selectedSiteId))[0];
  const newOrderSummaryData = orderSummaryData.filter((orderItem => orderItem.siteId !== selectedSiteId));
  const migrateCount = confirmOrderData.filter((optionData => optionData.id && optionData.id.startsWith(`migrate-${selectedSiteId}`)
    && optionData.checked)).length;
  const redirectCount = confirmOrderData.filter((optionData => optionData.id && optionData.id.startsWith(`redirect-${selectedSiteId}`)
    && optionData.checked)).length;
  const cancelCount = confirmOrderData.filter((optionData => optionData.id && optionData.id.startsWith(`cancel-${selectedSiteId}`)
    && optionData.checked)).length;

  const { serviceProductsArray } = serviceTermAuthorable;

  // Multiply each items price by its quantity or '0' if quantity is not defined,
  // Then add all the prices together working in cents so we don't get decimal accuracy issues
  const totalCost = (services => services.map(products => products.items.map(product => product.rentalPrice *
    (parseInt(deviceQuantityData.filter(
      quantityItem => quantityItem.id === `${products.deviceType}-${product.itemName}-${selectedSiteId}-quantity`)[0].quantity, 10) || 0)))
    .flat().reduce((a, b) => ((parseFloat(a, 10) * 100) + (parseFloat(b, 10) * 100)) / 100));

  const oneOffTotal = (services => totalCost(services.filter(service => service.paymentType === PAYMENT_TYPE_ONEOFF ||
    (serviceTermSelectedOption === SERVICE_TERM_PURCHASE_RADIO_BUTTON && service.paymentType !== PAYMENT_TYPE_MONTHLY))));

  const monthlyTotal = (services => totalCost(services.filter(service => service.paymentType === PAYMENT_TYPE_MONTHLY ||
  (serviceTermSelectedOption !== SERVICE_TERM_PURCHASE_RADIO_BUTTON && service.paymentType !== PAYMENT_TYPE_ONEOFF))));

  let siteContactValidateStatus = true;
  if (siteContactDetails) {
    const siteContactObject = siteContactDetails.filter((contact => contact.siteId === selectedSiteId));
    siteContactValidateStatus = validateSiteContactFormFieldsOnSubmit(siteContactObject);
  }

  const
    {
      confirmOrderDataAndUsageValidationData,
    } = confirmOrderDataAndUsageValidation(sitesData, stateData, selectedSiteId);

  const siteContactObject = siteContactDetails.filter((contact => contact.siteId === selectedSiteId))[0];
  const newSiteStatus = getSiteStatus(siteContactValidateStatus,
    confirmOrderDataAndUsageValidationData,
    siteContactObject.isSiteProcessed,
    migrateCount + redirectCount + cancelCount);

  siteOrderDataToBeChanged =
    {
      ...siteOrderDataToBeChanged,
      migratedServicesCount: migrateCount,
      redirectedServicesCount: redirectCount,
      cancelledServicesCount: cancelCount,
      monthlyCost: monthlyTotal(serviceProductsArray),
      onceOffCost: oneOffTotal(serviceProductsArray),
      siteStatus: newSiteStatus,
    };

  newOrderSummaryData.push(siteOrderDataToBeChanged);
  return newOrderSummaryData.sort((orderItem1, orderItem2) => orderItem1.sitePosition - orderItem2.sitePosition);
};

export const getIsdnRedirectCancelChecksData = (siteServices, redirectAllId, siteId) => {
  const newIsdnRedirectCancelChecks = {};
  if (redirectAllId) {
    newIsdnRedirectCancelChecks[`redirectAll-${siteId}`] = true;
    newIsdnRedirectCancelChecks[`cancelAll-${siteId}`] = false;
  } else {
    newIsdnRedirectCancelChecks[`cancelAll-${siteId}`] = true;
    newIsdnRedirectCancelChecks[`redirectAll-${siteId}`] = false;
  }

  siteServices.forEach((parentService) => {
    if (redirectAllId) {
      newIsdnRedirectCancelChecks[`redirect-${parentService.type}-${parentService.number}`] = true;
      newIsdnRedirectCancelChecks[`cancel-${parentService.type}-${parentService.number}`] = false;
    } else {
      newIsdnRedirectCancelChecks[`cancel-${parentService.type}-${parentService.number}`] = true;
      newIsdnRedirectCancelChecks[`redirect-${parentService.type}-${parentService.number}`] = false;
    }
    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        if (redirectAllId) {
          newIsdnRedirectCancelChecks[`redirect-PrimaryFNN-${childService.number}`] = true;
          newIsdnRedirectCancelChecks[`cancel-PrimaryFNN-${childService.number}`] = false;
        } else {
          newIsdnRedirectCancelChecks[`cancel-PrimaryFNN-${childService.number}`] = true;
          newIsdnRedirectCancelChecks[`redirect-PrimaryFNN-${childService.number}`] = false;
        }
      });
    }
  });

  return newIsdnRedirectCancelChecks;
};


export const prepareIsdnGoToOptionsSelections = (sitesData) => {
  const newIsdGoToOptions = sitesData.map(siteData => (
    {
      siteId: siteData.siteId,
      isdnGoTo: ISDN_GOTOOPTION_MIGRATE_ALL_BSIP,
    }
  ));
  return newIsdGoToOptions;
};


export const validateRedirectCancelSelectionForSite = (siteServices, isdnRedirectCancelChecks, isdnRedirectNumberData, isdnRedirectTypeData) => {
  let isValid = true;

  siteServices.forEach((parentService) => {
    if (isdnRedirectCancelChecks[`redirect-${parentService.type}-${parentService.number}`] === undefined &&
      isdnRedirectCancelChecks[`cancel-${parentService.type}-${parentService.number}`] === undefined) {
      isValid = false;
      return isValid;
    }
    if (isdnRedirectCancelChecks[`redirect-${parentService.type}-${parentService.number}`] &&
    (isdnRedirectNumberData[`redirectNumber-${parentService.type}-${parentService.number}`] === undefined ||
    isdnRedirectTypeData[`redirectType-${parentService.type}-${parentService.number}`] === undefined ||
    validatePhoneNumber(isdnRedirectNumberData[`redirectNumber-${parentService.type}-${parentService.number}`]) === false)) {
      isValid = false;
      return isValid;
    }
    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        if (isdnRedirectCancelChecks[`redirect-PrimaryFNN-${childService.number}`] === undefined &&
          isdnRedirectCancelChecks[`cancel-PrimaryFNN-${childService.number}`] === undefined) {
          isValid = false;
          return isValid;
        }
        if (isdnRedirectCancelChecks[`redirect-PrimaryFNN-${childService.number}`] &&
        (isdnRedirectNumberData[`redirectNumber-PrimaryFNN-${childService.number}`] === undefined ||
        isdnRedirectTypeData[`redirectType-PrimaryFNN-${childService.number}`] === undefined ||
        validatePhoneNumber(isdnRedirectNumberData[`redirectNumber-PrimaryFNN-${childService.number}`]) === false)) {
          isValid = false;
          return isValid;
        }
        return isValid;
      });
    }
    return isValid;
  });

  return isValid;
};

export const validateRedirectCancelSelectionForInDialSite = (siteId, inDialSiteServices,
  isdnInDialRedirectCancelChecks, isdnInDialRedirectNumberData, isdnInDialRedirectTypeData) => {
  let isValid = true;

  inDialSiteServices.forEach((service) => {
    if (isdnInDialRedirectCancelChecks[`${siteId}-indial-${service.serviceNumber}-redirect`] === undefined &&
    isdnInDialRedirectCancelChecks[`${siteId}-indial-${service.serviceNumber}-cancel`] === undefined) {
      isValid = false;
      return isValid;
    }
    if (isdnInDialRedirectCancelChecks[`${siteId}-indial-${service.serviceNumber}-redirect`] !== undefined &&
    (isdnInDialRedirectNumberData[`redirectNumber-${siteId}-indial-${service.serviceNumber}`] === undefined ||
    isdnInDialRedirectTypeData[`redirectType-${siteId}-indial-${service.serviceNumber}`] === undefined ||
    validatePhoneNumber(isdnInDialRedirectNumberData[`redirectNumber-${siteId}-indial-${service.serviceNumber}`]) === false
    )
    ) {
      isValid = false;
      return isValid;
    }
    return isValid;
  });
  return isValid;
};


export const checkSiteContactFieldsErrors = (contactSiteFieldsHasErrors, siteId) => {
  let isValid = true;
  const siteContactErrorData = contactSiteFieldsHasErrors.find(site => site.siteId === siteId);
  Object.keys(siteContactErrorData).forEach((item) => {
    if (item !== 'siteId') {
      isValid = isValid && !siteContactErrorData[item].invalid && siteContactErrorData[item].touched;
    }
  });
  return isValid;
};


export const prepareSitesBillingAccountNumbers = (sitesData, defaultAccountNumber) => {
  const sitesBillingData = {};
  sitesData.forEach((siteData) => {
    sitesBillingData[siteData.siteId] = defaultAccountNumber;
  });
  return sitesBillingData;
};

export const getCancelServiceStatus = (migrateStatus, isdnRedirectCancelChecks, siteService) => {
  if (migrateStatus === true) {
    return false;
  }
  if (siteService.type !== 'Auxillary') {
    return isdnRedirectCancelChecks[`cancel-${siteService.type}-${siteService.number}`] !== undefined ?
      isdnRedirectCancelChecks[`cancel-${siteService.type}-${siteService.number}`] : false;
  }
  return isdnRedirectCancelChecks[`cancel-PrimaryFNN-${siteService.primaryFNN}`] !== undefined ?
    isdnRedirectCancelChecks[`cancel-PrimaryFNN-${siteService.primaryFNN}`] : false;
};

export const getRedirectServiceStatus = (migrateStatus, isdnRedirectCancelChecks, siteService) => {
  if (migrateStatus === true) {
    return false;
  }
  if (siteService.type !== 'Auxillary') {
    return isdnRedirectCancelChecks[`redirect-${siteService.type}-${siteService.number}`] !== undefined ?
      isdnRedirectCancelChecks[`redirect-${siteService.type}-${siteService.number}`] : false;
  }
  return isdnRedirectCancelChecks[`redirect-PrimaryFNN-${siteService.primaryFNN}`] !== undefined ?
    isdnRedirectCancelChecks[`redirect-PrimaryFNN-${siteService.primaryFNN}`] : false;
};

export const getRedirectNumberValue = (migrateStatus, isdnRedirectCancelChecks, siteService, isdnRedirectNumberData) => {
  const isRedirect = getRedirectServiceStatus(migrateStatus, isdnRedirectCancelChecks, siteService);
  if (isRedirect) {
    if (siteService.type !== 'Auxillary') {
      return isdnRedirectNumberData[`redirectNumber-${siteService.type}-${siteService.number}`] &&
        validatePhoneNumber(isdnRedirectNumberData[`redirectNumber-${siteService.type}-${siteService.number}`]) ?
        isdnRedirectNumberData[`redirectNumber-${siteService.type}-${siteService.number}`] : null;
    }
    return isdnRedirectNumberData[`redirectNumber-PrimaryFNN-${siteService.primaryFNN}`] &&
      validatePhoneNumber(isdnRedirectNumberData[`redirectNumber-PrimaryFNN-${siteService.primaryFNN}`]) ?
      isdnRedirectNumberData[`redirectNumber-PrimaryFNN-${siteService.primaryFNN}`] : null;
  }
  return null;
};

export const getRedirectTypeValue = (migrateStatus, isdnRedirectCancelChecks, siteService, isdnRedirectTypeData) => {
  const isRedirect = getRedirectServiceStatus(migrateStatus, isdnRedirectCancelChecks, siteService);
  if (isRedirect) {
    if (siteService.type !== 'Auxillary') {
      return isdnRedirectTypeData[`redirectType-${siteService.type}-${siteService.number}`] ?
        isdnRedirectTypeData[`redirectType-${siteService.type}-${siteService.number}`] : null;
    }
    return isdnRedirectTypeData[`redirectType-PrimaryFNN-${siteService.primaryFNN}`] ?
      isdnRedirectTypeData[`redirectType-PrimaryFNN-${siteService.primaryFNN}`] : null;
  }
  return null;
};

export const getDeviceQuantityData = (serviceTermDeviceQuantityData, deviceId) => {
  const devicePresent = serviceTermDeviceQuantityData.find(item => item.id === deviceId);
  if (devicePresent) {
    return (devicePresent.quantity !== null && devicePresent.quantity.length > 0) ? parseInt(devicePresent.quantity, 10) : 0;
  }
  return null;
};


export const getAdvertiseNumberData = (migrateStatus, siteId, siteService, migrationAdvertiseChecks) => {
  if (migrateStatus) {
    if (siteService.type === 'GDN') {
      return migrationAdvertiseChecks[`${siteId}-${siteService.type}-${siteService.number}-checkbox`] ?
        migrationAdvertiseChecks[`${siteId}-${siteService.type}-${siteService.number}-checkbox`] : true;
    }
    return migrationAdvertiseChecks[`${siteId}-${siteService.type}-${siteService.number}-checkbox`] ?
      migrationAdvertiseChecks[`${siteId}-${siteService.type}-${siteService.number}-checkbox`] : false;
  }
  return null;
};

export const getMigrateStatus = (migrateStatus, siteProcessed, siteId) => {
  const isSiteProcessed = siteProcessed[siteId] !== undefined;
  return isSiteProcessed && migrateStatus;
};

export const getInDialMigrateStatus = (migrateStatus, migrateData, elementId) => (migrateStatus && migrateData[elementId] !== undefined);

export const getInDialRedirectStatus = (redirectStatus, redirectData, elementId) => (redirectStatus && redirectData[elementId] !== undefined);

export const getInDialRedirectData = (redirectStatus, redirectData, elementId) => (redirectStatus && redirectData[elementId] !== undefined ?
  redirectData[elementId] : null);

export const getInDialCancelStatus = (migrateGoToTiptOption, migrateGoToBsipOption,
  cancelGoToOption, migrateTiptData, migrateBsipData, cancelData, elementId) => {
  if (migrateGoToTiptOption) {
    return migrateTiptData[elementId] !== undefined;
  } else if (migrateGoToBsipOption) {
    return migrateBsipData[elementId] !== undefined;
  } else if (cancelGoToOption) {
    return cancelData[elementId] !== undefined;
  }
  return false;
};

export const getBsipContractTerm = (siteId, sitesBsipContractMonthsData) => {
  const contractTermText = sitesBsipContractMonthsData[siteId];
  const contractTermMonths = contractTermText.split(' ')[0];
  return contractTermMonths;
};

export const getNumberOfTrunks = (siteServices) => {
  let numberOfTrunks = 0;
  siteServices.forEach((service) => {
    if (service.type === 'PrimaryFNN') {
      numberOfTrunks += 1;
    }
    if (service.primaryList && service.primaryList.length > 0) {
      numberOfTrunks += service.primaryList.length;
    }
  });
  return numberOfTrunks * 2;
};

export const getNumberOfTrunksInDial = (inDialServices, isdnInDialBsipServiceMigrateCancelCheckList, siteId) => {
  let numberOfTrunks = 0;
  inDialServices.forEach((service) => {
    const isCancel = isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${service.serviceNumber}-cancel`] !== undefined;
    if (isCancel === false) {
      numberOfTrunks += parseInt(service.numberOfTrunks, 10);
    }
  });
  return numberOfTrunks;
};

export const getInDialNumberBlocksCount = (inDialServices, isdnInDialBsipServiceMigrateCancelCheckList, siteId) => {
  let numberOfBlocks = 0;
  inDialServices.forEach((service) => {
    const isCancel = isdnInDialBsipServiceMigrateCancelCheckList[`${siteId}-indial-${service.serviceNumber}-cancel`] !== undefined;
    if (isCancel === false) {
      numberOfBlocks += service.numberRanges.length;
    }
  });
  return numberOfBlocks;
};

export const getNumberOfTelephoneNumbers = (siteServices) => {
  const siteServicesArray = [];
  siteServices.forEach((parentService) => {
    siteServicesArray.push({ type: parentService.type, number: parentService.number, primaryFNN: '' });
    if (parentService.primaryList && parentService.primaryList.length > 0) {
      parentService.primaryList.forEach((childService) => {
        siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number, primaryFNN: childService.number });

        childService.auxList.forEach((auxService) => {
          siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: childService.number });
        });
      });
    } else {
      parentService.auxList.forEach((auxService) => {
        siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: parentService.number });
      });
    }
  });
  return siteServicesArray.length;
};

const getCallCenterItemsValuesCount = (inDialUserTypeData, callCenterElement, siteId) => {
  let matchingElementCount = 0;
  Object.entries(inDialUserTypeData).forEach(([key, value]) => {
    if (key.includes(siteId) && value === callCenterElement) {
      matchingElementCount += 1;
    }
  });
  return matchingElementCount;
};

const serviceNumberHasError2 = (elementId, serviceNumberData) => {
  const serviceNumberValues = Object.values(serviceNumberData);
  if (serviceNumberValues.length > 0) {
    const duplicateValuesPresent = serviceNumberValues.filter(item => item === serviceNumberData[elementId]);
    return duplicateValuesPresent.length > 1;
  }
  return false;
};


export const getNumberListFromNumberRange = (numberRange) => {
  const numberList = [];
  const splittedData = numberRange.split(' ');
  const startNumber = splittedData[0];
  const endNumber = splittedData[2];

  for (let i = parseInt(startNumber, 10); i <= parseInt(endNumber, 10); i += 1) {
    const serviceNumber = `0${i}`;
    numberList.push(serviceNumber);
  }
  return numberList;
};


export const getInDialServiceNumberList = (inDialServiceDataList, isdnInDialTiptServiceMigrateCancelCheckList, siteId) => {
  let serviceNumberList = [];
  inDialServiceDataList.forEach((dataItem) => {
    const isCancel = isdnInDialTiptServiceMigrateCancelCheckList[`${siteId}-indial-${dataItem.serviceNumber}-cancel`] !== undefined;
    if (isCancel === false) {
      dataItem.numberRanges.forEach((numberRange) => {
        const numberList = getNumberListFromNumberRange(numberRange);
        serviceNumberList = [...serviceNumberList, ...numberList];
      });
    }
  });
  return serviceNumberList;
};


const getInDialNumberDetailingData = (migrationCounts, inDialUserTypeData, inDialUserNamesData,
  inDialServiceNumberData, firstNamePlaceholder, lastNamePlaceholder, siteId, validNumberList) => {
  let inDialNumberDetailingData = [];
  // first the deskphones
  const deskPhoneCount = migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] }, (v, i) => i) : [];
  let index = 1;
  deskPhoneCount.forEach(() => {
    const serviceNumberData = inDialServiceNumberData[`${siteId}-${PORT_TYPE_P_PHONE}-servicenumber-${index}`];
    const serviceNumberInCompleteError = serviceNumberData === undefined || serviceNumberData.length === 0;
    const ServiceNumberDupesError = serviceNumberHasError2(`${siteId}-${PORT_TYPE_P_PHONE}-servicenumber-${index}`,
      inDialServiceNumberData);

    if (serviceNumberInCompleteError === false && ServiceNumberDupesError === false && validNumberList.includes(serviceNumberData)) {
      const deskPhoneItem = {
        intendedUse: 'Desk phone',
        serviceNumber: inDialServiceNumberData[`${siteId}-${PORT_TYPE_P_PHONE}-servicenumber-${index}`],
        assignedFirstName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_P_PHONE}-firstname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_P_PHONE}-firstname-${index}`] : firstNamePlaceholder,
        assignedLastName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_P_PHONE}-lastname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_P_PHONE}-lastname-${index}`] : `${lastNamePlaceholder} ${index}`,
        userNumberType: inDialUserTypeData[`${siteId}-${PORT_TYPE_P_PHONE}-usertype-${index}`] !== undefined ?
          inDialUserTypeData[`${siteId}-${PORT_TYPE_P_PHONE}-usertype-${index}`] : 'notapplicable',
      };
      inDialNumberDetailingData = [...inDialNumberDetailingData, deskPhoneItem];
    }
    index += 1;
  });

  // mobiles
  const mobileCount = migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] }, (v, i) => i) : [];
  index = 1;
  mobileCount.forEach(() => {
    const serviceNumberData = inDialServiceNumberData[`${siteId}-${PORT_TYPE_MOBILE}-servicenumber-${index}`];
    const serviceNumberInCompleteError = serviceNumberData === undefined || serviceNumberData.length === 0;
    const ServiceNumberDupesError = serviceNumberHasError2(`${siteId}-${PORT_TYPE_MOBILE}-servicenumber-${index}`,
      inDialServiceNumberData);

    if (serviceNumberInCompleteError === false && ServiceNumberDupesError === false && validNumberList.includes(serviceNumberData)) {
      const mobileItem = {
        intendedUse: 'Liberate Mobile',
        serviceNumber: inDialServiceNumberData[`${siteId}-${PORT_TYPE_MOBILE}-servicenumber-${index}`],
        assignedFirstName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_MOBILE}-firstname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_MOBILE}-firstname-${index}`] : firstNamePlaceholder,
        assignedLastName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_MOBILE}-lastname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_MOBILE}-lastname-${index}`] : `${lastNamePlaceholder} ${deskPhoneCount.length + index}`,
        userNumberType: inDialUserTypeData[`${siteId}-${PORT_TYPE_MOBILE}-usertype-${index}`] !== undefined ?
          inDialUserTypeData[`${siteId}-${PORT_TYPE_MOBILE}-usertype-${index}`] : 'notapplicable',
      };
      inDialNumberDetailingData = [...inDialNumberDetailingData, mobileItem];
    }
    index += 1;
  });

  // analog
  const analogCount = migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined ?
    Array.from({ length: migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] }, (v, i) => i) : [];
  index = 1;
  analogCount.forEach(() => {
    const serviceNumberData = inDialServiceNumberData[`${siteId}-${PORT_TYPE_ANALOG}-servicenumber-${index}`];
    const serviceNumberInCompleteError = serviceNumberData === undefined || serviceNumberData.length === 0;
    const ServiceNumberDupesError = serviceNumberHasError2(`${siteId}-${PORT_TYPE_ANALOG}-servicenumber-${index}`,
      inDialServiceNumberData);

    if (serviceNumberInCompleteError === false && ServiceNumberDupesError === false && validNumberList.includes(serviceNumberData)) {
      const analogItem = {
        intendedUse: 'Analog',
        serviceNumber: inDialServiceNumberData[`${siteId}-${PORT_TYPE_ANALOG}-servicenumber-${index}`],
        assignedFirstName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_ANALOG}-firstname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_ANALOG}-firstname-${index}`] : firstNamePlaceholder,
        assignedLastName: inDialUserNamesData &&
          inDialUserNamesData[`${siteId}-${PORT_TYPE_ANALOG}-lastname-${index}`] !== undefined ?
          inDialUserNamesData[`${siteId}-${PORT_TYPE_ANALOG}-lastname-${index}`]
          : `${lastNamePlaceholder} ${deskPhoneCount.length + mobileCount.length + index}`,
        userNumberType: null,
      };
      inDialNumberDetailingData = [...inDialNumberDetailingData, analogItem];
    }
    index += 1;
  });

  return inDialNumberDetailingData;
};

export const getInDialNumberRangesCount = (inDialServiceDataList) => {
  let numberRangeCount = 0;
  inDialServiceDataList.forEach((dataItem) => {
    dataItem.numberRanges.forEach(() => {
      numberRangeCount += 1;
    });
  });
  return numberRangeCount;
};

const isVendorSelected = vendorKey => (vendorKey !== SIP_CONNECT_NO_PABX &&
  vendorKey !== SIP_CONNECT_PABX_NOT_LISTED && vendorKey !== SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION);

export const getSipConnectdevice = (sitesSipConnectPabxVendor, sitesSipConnectPabxModel, sitesSipConnectNumberOfTrunks,
  siteId, inDial, ISDN2) => {
  if (sitesSipConnectPabxVendor[siteId] === undefined || (sitesSipConnectPabxVendor[siteId] !== undefined &&
    sitesSipConnectPabxVendor[siteId] === SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)) {
    return false;
  } else if (inDial === false && ISDN2 === true) {
    if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
    sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
      return IAD_DEVICE_NOT_REQUIRED;
    }
    return IAD_DEVICE_425;
  } else if (inDial === true && ISDN2 === true) {
    if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
    sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
      return IAD_DEVICE_NOT_REQUIRED;
    }
    return IAD_DEVICE_425;
  } else if (inDial === true && ISDN2 === false) {
    if (sitesSipConnectPabxVendor[siteId] !== undefined && isVendorSelected(sitesSipConnectPabxVendor[siteId]) &&
    sitesSipConnectPabxModel[siteId] !== undefined && sitesSipConnectPabxModel[siteId] !== SIP_CONNECT_PABX_MODEL_NOT_LISTED) {
      return IAD_DEVICE_NOT_REQUIRED;
    } else if (sitesSipConnectNumberOfTrunks[siteId] <= 30) {
      return IAD_DEVICE_270;
    } else if (sitesSipConnectNumberOfTrunks[siteId] > 30 && sitesSipConnectNumberOfTrunks[siteId] <= 60) {
      return IAD_DEVICE_700;
    }
  }
  return false;
};

export const getSipConnectDeviceName = (sitesSipConnectPabxVendor, sitesSipConnectPabxModel, sitesSipConnectNumberOfTrunks,
  siteId, inDial, ISDN2) => {
  const devicecode = getSipConnectdevice(sitesSipConnectPabxVendor, sitesSipConnectPabxModel, sitesSipConnectNumberOfTrunks,
    siteId, inDial, ISDN2);
  switch (devicecode) {
    case IAD_DEVICE_NOT_REQUIRED:
      return IAD_DEVICE_NOT_REQUIRED;
    case IAD_DEVICE_425:
      return ONE_425;
    case IAD_DEVICE_270:
      return ONE_270;
    case IAD_DEVICE_700:
      return ONE_700;
    default:
      return '';
  }
};

export const getSipConnectNumberOfTrunks = (sitesSipConnectNumberOfTrunks, siteId, inDial, ISDN2, deviceName) => {
  let numberOfTrunks = 0;
  if (inDial && ISDN2 && deviceName !== IAD_DEVICE_NOT_REQUIRED) {
    numberOfTrunks = (sitesSipConnectNumberOfTrunks !== undefined && sitesSipConnectNumberOfTrunks[siteId])
      ? parseInt(sitesSipConnectNumberOfTrunks[siteId], 10) : 0;
  } else {
    numberOfTrunks = (sitesSipConnectNumberOfTrunks !== undefined && sitesSipConnectNumberOfTrunks[siteId])
      ? parseInt(sitesSipConnectNumberOfTrunks[siteId], 10) : 0;
  }

  return numberOfTrunks;
};

const getOptionValue = (key, optionsList) => {
  const option = optionsList.find(optionItem => optionItem.key === key);
  if (option) {
    return option.value;
  }
  return '';
};


export const prepareISDNSubmitCustomerData = (stateData, sitesData, authorableData) => {
  let isdnCustomerSitesData = []; // this holds complete ISDN Customer Data
  sitesData.forEach((siteData) => {
    const siteServicesArray = [];
    let inDialsiteServicesArray = [];
    const isdnOptionSelectedSite = stateData.isdnGoToOptions.filter(isdnOption => isdnOption.siteId === siteData.siteId)[0];
    const migrateAllToTiptRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT;
    const migrateAllToBsipRadioButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP;
    const migrateAllToSipConnectButtonChecked = isdnOptionSelectedSite && isdnOptionSelectedSite.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT;
    const migrateToEnterpriseTrunk = stateData.sitesSIPInDialMigrateToEnterpriseTrunk[`${siteData.siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`];
    const sitesSIPInDialMigrateToEnterpriseTrunkSelection = stateData.sitesSIPInDialMigrateToEnterpriseTrunkSelection;
    if (siteData.inDial === false) {
      siteData.siteServices.forEach((parentService) => {
        siteServicesArray.push({ type: parentService.type, number: parentService.number, primaryFNN: '' });
        if (parentService.primaryList && parentService.primaryList.length > 0) {
          parentService.primaryList.forEach((childService) => {
            siteServicesArray.push({ type: 'PrimaryFNN', number: childService.number, primaryFNN: childService.number });
            childService.auxList.forEach((auxService) => {
              siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: childService.number });
              sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${auxService}`] =
                sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${childService.number}`];
            });
          });
        } else {
          parentService.auxList.forEach((auxService) => {
            siteServicesArray.push({ type: 'Auxillary', number: auxService, primaryFNN: parentService.number });
            sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${auxService}`] =
                sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${parentService.number}`];
          });
        }
      });
    } else {
      siteData.inDialServices.forEach((service) => {
        const migrateElementId = `${siteData.siteId}-indial-${service.serviceNumber}-migrate`;
        const cancelElementId = `${siteData.siteId}-indial-${service.serviceNumber}-cancel`;
        const redirectElementId = `${siteData.siteId}-indial-${service.serviceNumber}-redirect`;
        const redirectTypeElementId = `redirectType-${siteData.siteId}-indial-${service.serviceNumber}`;
        const redirectNumberElementId = `redirectNumber-${siteData.siteId}-indial-${service.serviceNumber}`;
        const cancelGoToOption = migrateAllToTiptRadioButtonChecked === false && migrateAllToBsipRadioButtonChecked === false;
        const enterpriseTrunkSelected = (migrateToEnterpriseTrunk && siteData.enterpriseTrunking) ?
          sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${service.serviceNumber}`] : null;
        const serviceItem = {
          dn: service.serviceNumber,
          numberRanges: service.numberRanges,
          numberOfTrunks: service.numberOfTrunks,
          advertisedNumber: null,
          migrate: getInDialMigrateStatus(migrateAllToTiptRadioButtonChecked, stateData.isdnInDialTiptServiceMigrateCancelCheckList,
            migrateElementId),
          migrateToBsip: getInDialMigrateStatus(migrateAllToBsipRadioButtonChecked, stateData.isdnInDialBsipServiceMigrateCancelCheckList,
            migrateElementId),
          migrateToSIPConnect: migrateAllToSipConnectButtonChecked,
          cancel: getInDialCancelStatus(migrateAllToTiptRadioButtonChecked, migrateAllToBsipRadioButtonChecked, cancelGoToOption,
            stateData.isdnInDialTiptServiceMigrateCancelCheckList, stateData.isdnInDialBsipServiceMigrateCancelCheckList,
            stateData.isdnInDialServiceRedirectCancelCheckList, cancelElementId),
          redirect: getInDialRedirectStatus(cancelGoToOption, stateData.isdnInDialServiceRedirectCancelCheckList, redirectElementId),
          redirectType: getInDialRedirectData(cancelGoToOption, stateData.isdnInDialRedirectTypeData, redirectTypeElementId),
          redirectNumber: getInDialRedirectData(cancelGoToOption, stateData.isdnInDialRedirectNumberData, redirectNumberElementId),
          enterpriseTrunkSelected,
        };
        inDialsiteServicesArray = [...inDialsiteServicesArray, serviceItem];
      });
    }

    let multiNumberSiteServices = []; // this holds the siteServices data for multi number  for each siteId
    siteServicesArray.forEach((siteService) => {
      const enterpriseTrunkSelected = (migrateToEnterpriseTrunk && siteData.enterpriseTrunking) ?
        sitesSIPInDialMigrateToEnterpriseTrunkSelection[`${siteData.siteId}-${siteService.number}`] : null;
      const siteServiceItem = {
        dn: siteService.number,
        migrate: getMigrateStatus(migrateAllToTiptRadioButtonChecked,
          stateData.siteProcessed, siteData.siteId),
        migrateToBsip: getMigrateStatus(migrateAllToBsipRadioButtonChecked,
          stateData.siteProcessed, siteData.siteId),
        migrateToSIPConnect: migrateAllToSipConnectButtonChecked,
        cancel: getCancelServiceStatus((migrateAllToTiptRadioButtonChecked || migrateAllToBsipRadioButtonChecked),
          stateData.isdnRedirectCancelChecks, siteService),
        redirect: getRedirectServiceStatus((migrateAllToTiptRadioButtonChecked || migrateAllToBsipRadioButtonChecked),
          stateData.isdnRedirectCancelChecks, siteService),
        redirectType: getRedirectTypeValue((migrateAllToTiptRadioButtonChecked || migrateAllToBsipRadioButtonChecked),
          stateData.isdnRedirectCancelChecks, siteService, stateData.isdnRedirectTypeData),
        redirectNumber: getRedirectNumberValue((migrateAllToTiptRadioButtonChecked || migrateAllToBsipRadioButtonChecked),
          stateData.isdnRedirectCancelChecks, siteService, stateData.isdnRedirectNumberData),
        advertisedNumber: getAdvertiseNumberData(migrateAllToTiptRadioButtonChecked,
          siteData.siteId, siteService, stateData.migrationAdvertiseChecks),
        numberRanges: null,
        numberOfTrunks: null,
        enterpriseTrunkSelected,
      };
      multiNumberSiteServices = [...multiNumberSiteServices, siteServiceItem];
    });
    const userFormFieldsDataForSubmission = stateData.formFields.filter(formField => formField.siteId === siteData.siteId)[0];
    const siteDelieveryAddressData = stateData.deliveryAddressesData
      .filter(address => address.siteId === siteData.siteId)[0].modifiedDetailedAddresObject.fullAddress;
    const usrSiteId = getUserSiteId(stateData.deliveryAddressesData, siteData.siteId);

    const serviceTermDataObject = stateData.serviceTermConnectionDateData.find(item => item.siteId === siteData.siteId);
    const serviceTermObject = {
      tiptServiceChoice: serviceTermDataObject.purchaseRentalSelectedOption,
      feauturePackBasicQuantity: stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] ?
        parseInt(stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`], 10) : null,
      feauturePackStandardQuantity: stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`] ?
        parseInt(stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`], 10) : null,
      liberateMobilePackQuantity: stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_MOBILE}`] ?
        parseInt(stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_MOBILE}`], 10) : null,
      handsetsQuantity: stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`] ?
        parseInt(stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`], 10) : null,
      powerPackQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${SERVICE_TERM_DEVICE_TYPE_POWERPACKS}-PolycomPSVVX301-${siteData.siteId}-quantity`),
      headsetJabraQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${SERVICE_TERM_DEVICE_TYPE_HEADSET}-headsetJabra40-${siteData.siteId}-quantity`),
      headsetPlantronicsQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${SERVICE_TERM_DEVICE_TYPE_HEADSET}-headsetPlantronics-${siteData.siteId}-quantity`),
      iadTwoPortQuantity: (stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] <= 2
        && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] > 0) ? 1 : 0,
      iadEightPortQuantity: stateData.migrationCounts && stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] > 2 ? 1 : 0,
      billingAccountNumber: stateData.sitesBillingAccountNumber[siteData.siteId],
      importantDate: null,
      miReception: getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'mireception', siteData.siteId),
      callCentreAgentStandard: getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'callcenteragentstandard', siteData.siteId),
      callCentreAgentPremium: getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'callcenteragentpremium', siteData.siteId),
      callCentreSupervisorStandard: getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'callcentersupervisorstandard', siteData.siteId),
      callCentreSupervisorPremium: getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'callcentersupervisorpremium', siteData.siteId),
      miReceptionCallCentreAgentStandard:
        getCallCenterItemsValuesCount(stateData.inDialUserTypeData, 'mireceptioncallcenteragentstandard', siteData.siteId),

    };
    const emptyServiceTermObject = {
      tiptServiceChoice: null,
      feauturePackBasicQuantity: null,
      feauturePackStandardQuantity: null,
      handsetsQuantity: null,
      powerPackQuantity: null,
      headsetJabraQuantity: null,
      headsetPlantronicsQuantity: null,
      iadTwoPortQuantity: null,
      iadEightPortQuantity: null,
      billingAccountNumber: stateData.sitesBillingAccountNumber[siteData.siteId],
      importantDate: null,
      miReception: null,
      callCentreAgentStandard: null,
      callCentreAgentPremium: null,
      callCentreSupervisorStandard: null,
      callCentreSupervisorPremium: null,
      miReceptionCallCentreAgentStandard: null,
    };

    const emptyBsipServiceTermObject = {
      callingPlan: null,
      contractTerm: null,
      businessContinuityQuantity: null,
      businessLineQuantity: null,
      mobilityQuantity: null,
      singleNumberQuantity: null,
      bsipCallingPlanQuantity: null,
      ntuQuantity: null,
      firstBlock: null,
      subsequentBlock: null,
    };

    const inDialNumberRangesCount = siteData.inDial ? getInDialNumberBlocksCount(siteData.inDialServices,
      stateData.isdnInDialBsipServiceMigrateCancelCheckList, siteData.siteId) : 0;

    const bsipServiceTerm = {
      callingPlan: stateData.sitesBsipCallingPlanSelection[siteData.siteId],
      contractTerm: getBsipContractTerm(siteData.siteId, stateData.sitesBsipContractMonthsData),
      businessContinuityQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-businessContinuity-${siteData.siteId}-quantity`),
      businessLineQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-businessLine-${siteData.siteId}-quantity`),
      mobilityQuantity: getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
        `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-mobility-${siteData.siteId}-quantity`),
      singleNumberQuantity: getNumberOfTelephoneNumbers(siteData.siteServices),
      bsipCallingPlanQuantity: siteData.inDial ? getNumberOfTrunksInDial(siteData.inDialServices,
        stateData.isdnInDialBsipServiceMigrateCancelCheckList, siteData.siteId) : getNumberOfTrunks(siteData.siteServices),
      ntuQuantity: authorableData.ntuDefaultQuantity,
      firstBlock: inDialNumberRangesCount > 0 ? 1 : 0,
      subsequentBlock: inDialNumberRangesCount > 0 ? inDialNumberRangesCount - 1 : 0,
    };

    const inDialTiptValidServiceNumberList = getInDialServiceNumberList(siteData.inDialServices,
      stateData.isdnInDialTiptServiceMigrateCancelCheckList, siteData.siteId);

    /** set Migrate to SIP Connect details */
    const sipConnectBusinessContinuityQuantity = getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
      `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${BUSINESS_CONTINUITY}-${siteData.siteId}-quantity`);

    const sipConnectMobilityQuantity = getDeviceQuantityData(stateData.serviceTermDeviceQuantityData,
      `${BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS}-${MOBILITY_CONTINUITY}-${siteData.siteId}-quantity`);

    const sipServiceTerm = {
      sipConnectCallingPlan: (siteData.inDial === false) ? BUSINESS_LINE : BUSINESS_TRUNK,
      pabxVendor: (stateData.sitesSipConnectPabxVendor !== undefined && stateData.sitesSipConnectPabxVendor[siteData.siteId])
        ? stateData.sitesSipConnectPabxVendor[siteData.siteId] : '',
      pabxModel: (stateData.sitesSipConnectPabxModel !== undefined && stateData.sitesSipConnectPabxModel[siteData.siteId])
        ? stateData.sitesSipConnectPabxModel[siteData.siteId] : '',
      numberOfTrunks: getSipConnectNumberOfTrunks(stateData.sitesSipConnectNumberOfTrunks, siteData.siteId,
        siteData.inDial, siteData.iSDN2, getSipConnectDeviceName(stateData.sitesSipConnectPabxVendor, stateData.sitesSipConnectPabxModel,
          stateData.sitesSipConnectNumberOfTrunks, siteData.siteId, siteData.inDial, siteData.iSDN2)),
      sipConnectContractTerm: (stateData.sitesSipContractMonthsData !== undefined && stateData.sitesSipContractMonthsData[siteData.siteId])
        ? stateData.sitesSipContractMonthsData[siteData.siteId] : '',
      iadDevice: getSipConnectDeviceName(stateData.sitesSipConnectPabxVendor, stateData.sitesSipConnectPabxModel,
        stateData.sitesSipConnectNumberOfTrunks, siteData.siteId, siteData.inDial, siteData.iSDN2),
      sipConnectBusinessContinuityFeaturePackQuantity: sipConnectBusinessContinuityQuantity !== null ? sipConnectBusinessContinuityQuantity : 0,
      sipConnectMobilityFeaturePackQuantity: sipConnectMobilityQuantity,
      pabxVendorValue: (stateData.sitesSipConnectPabxVendor !== undefined && stateData.sitesSipConnectPabxVendor[siteData.siteId])
        ? getOptionValue(stateData.sitesSipConnectPabxVendor[siteData.siteId], authorableData.pabxVendor.options) : '',
    };

    const emptySipServiceTerm = {
      sipConnectCallingPlan: null,
      pabxVendor: null,
      pabxModel: null,
      numberOfTrunks: 0,
      sipConnectContractTerm: null,
      iadDevice: null,
      sipConnectBusinessContinuityFeaturePackQuantity: 0,
      sipConnectMobilityFeaturePackQuantity: (migrateAllToSipConnectButtonChecked && migrateToEnterpriseTrunk) ? sipConnectMobilityQuantity : 0,
      pabxVendorValue: null,
    };

    const isdnCustomerDataItem = {
      siteId: siteData.siteId,
      goToOptions: isdnOptionSelectedSite.isdnGoTo,
      usrSiteId,
      usrChangedDetails: true,
      usrLvlUnitNum: usrSiteId ? null : siteData.siteLvlUnitNum,
      usrPropertyNum: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails &&
        siteDelieveryAddressData.propertyAddressDetails.propertyNumberFrom : siteData.sitePropertyNum,
      usrStName: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails &&
        siteDelieveryAddressData.propertyAddressDetails.streetDetails.streetName : siteData.siteStName,
      usrStType: usrSiteId ? siteDelieveryAddressData.propertyAddressDetails &&
        siteDelieveryAddressData.propertyAddressDetails.streetDetails.streetType : siteData.siteStType,
      usrSuburb: usrSiteId ? siteDelieveryAddressData.localityDetails.locality : siteData.siteSuburb,
      usrState: usrSiteId ? siteDelieveryAddressData.localityDetails.state : siteData.siteState,
      usrPostcode: usrSiteId ? siteDelieveryAddressData.localityDetails.postCode : siteData.sitePostcode,
      usrAddSiteNotes: userFormFieldsDataForSubmission[SERVICE_TERM_ADDITIONAL_INFO] !== undefined
        ? userFormFieldsDataForSubmission[SERVICE_TERM_ADDITIONAL_INFO] : null,
      usrSiteContactFirstName: checkUserChangedFormFields(userFormFieldsDataForSubmission, SITE_CONTACT_FIRST_NAME),
      usrSiteContactLastName: checkUserChangedFormFields(userFormFieldsDataForSubmission, SITE_CONTACT_LAST_NAME),
      usrSiteContactEmail: checkUserChangedFormFields(userFormFieldsDataForSubmission, SITE_CONTACT_EMAIL),
      usrSiteContactPhone: checkUserChangedFormFields(userFormFieldsDataForSubmission, SITE_CONTACT_PHONE),
      numberOfPhoneUsers: stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`] ?
        stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_P_PHONE}`] : null,
      numberOfAnalogueDevices: stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] ?
        stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_ANALOG}`] : null,
      numberOfLiberateMobileDevices: stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_MOBILE}`] ?
        stateData.migrationCounts[`${siteData.siteId}-${PORT_TYPE_MOBILE}`] : null,
      siteServices: siteData.inDial === false ? multiNumberSiteServices : inDialsiteServicesArray,
      serviceTerm: migrateAllToTiptRadioButtonChecked ? serviceTermObject : emptyServiceTermObject,
      serviceTermBSIP: migrateAllToBsipRadioButtonChecked ? bsipServiceTerm : emptyBsipServiceTermObject,
      indialNumberDetailing: siteData.inDial ?
        getInDialNumberDetailingData(stateData.migrationCounts, stateData.inDialUserTypeData,
          stateData.inDialUserNamesData, stateData.inDialServiceNumberData, authorableData.inDialNumberDetailFirstName,
          authorableData.inDialNumberDetailLasttName, siteData.siteId, inDialTiptValidServiceNumberList)
        : [],
      serviceTermSIPConnect: (migrateAllToSipConnectButtonChecked && !migrateToEnterpriseTrunk) ? sipServiceTerm : emptySipServiceTerm,
      migrateToEnterpriseTrunk,
    };
    isdnCustomerSitesData = [...isdnCustomerSitesData, isdnCustomerDataItem];
  });
  const isdnCustomerData = {
    confirmChanges: true, // always true in site by site
    // if a single site , then we returning an object in siteData, instead of array of objects
    sitesData: sitesData.length === 1 ? isdnCustomerSitesData[0] : isdnCustomerSitesData,
  };
  return isdnCustomerData;
};


export const getNextInValidSite = (sitesData, sitesError) => {
  let firstInValidSite = null;
  let siteFound = false;
  Object.keys(sitesError).forEach((site) => {
    if (sitesError[site] && !siteFound) {
      firstInValidSite = site;
      siteFound = true;
    }
  });
  return sitesData.find(site => site.siteId === firstInValidSite);
};

export const getNoOfPhoneAndAnalogDevicesSiteErrors = (siteId, migrationCountErrors) => {
  const phoneError = migrationCountErrors[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined ?
    migrationCountErrors[`${siteId}-${PORT_TYPE_P_PHONE}`] : true;

  const analogError = migrationCountErrors[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined ?
    migrationCountErrors[`${siteId}-${PORT_TYPE_ANALOG}`] : true;

  const mobileError = migrationCountErrors[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined ?
    migrationCountErrors[`${siteId}-${PORT_TYPE_MOBILE}`] : true;

  return phoneError || analogError || mobileError;
};

export const getZeroErrorForMigrationCountForSite = (siteId, migrationCounts) => {
  const pPhoneValue = migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] : -1;
  const analogValue = migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] : -1;
  const mobileValue = migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] : -1;

  return (parseInt(pPhoneValue, 10) === 0 && parseInt(analogValue, 10) === 0 && parseInt(mobileValue, 10) === 0) ||
   (parseInt(pPhoneValue, 10) === -1 && parseInt(analogValue, 10) === -1 && parseInt(mobileValue, 10) === -1);
};

export const setFirstErrorSectionIntoView = (validationResult) => {
  if (validationResult.siteContactErrorPresent) {
    scrollElementIntoView('site-details-heading');
  } else if (validationResult.siteTableErrorPresent) {
    scrollElementIntoView('service-heading');
  } else if (validationResult.sitePhonesAnalogueDevicesErrorPresent) {
    scrollElementIntoView('migration-count-section');
  }
};

export const atLeast1SiteHasMigrateToBsip = (isdnGoToOptions, siteProcessed) => {
  let migrateToBsipPresent = false;
  let itemMatchedToBsip = false;
  isdnGoToOptions.forEach((item) => {
    if (siteProcessed[item.siteId] !== undefined && siteProcessed[item.siteId] &&
       item.isdnGoTo === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP && itemMatchedToBsip === false) {
      migrateToBsipPresent = true;
      itemMatchedToBsip = true;
    }
  });
  return migrateToBsipPresent;
};

export const prepareSitesBsipCallingPlan = (sitesData) => {
  const sitesBsipCallingPlanData = {};
  sitesData.forEach((siteData) => {
    sitesBsipCallingPlanData[`${siteData.siteId}`] = BSIP_CALLING_PLAN_SMALL;
  });
  return sitesBsipCallingPlanData;
};

export const prepareSitesBsipContractMonthsSelection = (sitesData) => {
  const sitesBsipContractMonthsData = {};
  sitesData.forEach((siteData) => {
    sitesBsipContractMonthsData[`${siteData.siteId}`] = BSIP_SERVICE_TERM_DEFAULT_CONTRACT_TERM;
  });
  return sitesBsipContractMonthsData;
};

export const prepareSitesSipConnectContractMonthsSelection = (sitesData) => {
  const sitesSipContractMonthsData = {};
  sitesData.forEach((siteData) => {
    sitesSipContractMonthsData[`${siteData.siteId}`] = SIP_CONNECT_SERVICE_TERM_DEFAULT_CONTRACT_TERM;
  });
  return sitesSipContractMonthsData;
};


export const prepareIsdnCallbackData = (callBackPhoneNumber) => {
  const isdnCallbackData = { alternateContactNumber: callBackPhoneNumber };
  return isdnCallbackData;
};

export const successfulSubmissionOfIsdnRequestCallback = (response) => {
  const { data } = response;
  return { type: COMPLETE_ISDN_CALLBACK_REQUEST, data };
};

export const submitIsdnRequestCallback = data => (dispatch) => {
  const endpoint = ISDN_CALLBACK_REQUEST_ENDPOINT;
  const dataWithEncryptedCidn = {
    ...data,
    value: window.parent.tcom.researchInsights.appConfig.currentAccount,
  };
  dispatch({ type: INITIATE_ISDN_CALLBACK_REQUEST });
  apiPost(dispatch, endpoint, successfulSubmissionOfIsdnRequestCallback, failureAction, dataWithEncryptedCidn);
};

export const setDeviceQuantityData = (deviceType, deviceCode, siteId, quantity) => {
  const deviceQuantityData = {
    id: `${deviceType}-${deviceCode}-${siteId}-quantity`,
    quantity: quantity !== undefined ? quantity.toString() : '',
  };
  return deviceQuantityData;
};

export const getsiteServiceDetailsArrayWithDNkey = (siteServiceDetails) => {
  const siteServiceDetailsArray = {};
  siteServiceDetails.forEach((data) => {
    siteServiceDetailsArray[data.dn] = {
      advertisedNumber: data.advertisedNumber,
      redirect: data.redirect,
      cancel: data.cancel,
      redirectType: data.redirectType,
      redirectNumber: data.redirectNumber,
    };
  });
  return siteServiceDetailsArray;
};


export const getSavedDataObjects = (sitesData, authorableContent) => {
  let reLoadingData = {};
  let siteFormFields = [];
  let contactSiteFieldsHasErrors = [];
  let siteIsdnGoToOptions = [];
  let siteDeliveryAddressesData = [];
  const siteMigrationCounts = {};
  const siteInDialUserNamesData = {};
  const siteInDialServiceNumberData = {};
  const siteInDialUserTypeData = {};
  const siteIsdnInDialTiptServiceMigrateCancelCheckList = {};
  const siteIsdnInDialBsipServiceMigrateCancelCheckList = {};
  const siteIsdnInDialServiceRedirectCancelCheckList = {};
  const siteIsdnInDialRedirectTypeData = {};
  const siteIsdnInDialRedirectNumberData = {};
  let siteServiceTermConnectionDateData = [];
  const siteServiceTermDeviceQuantityData = [];
  const siteSitesBsipCallingPlanSelection = {};
  const siteSitesBsipContractMonthsData = {};
  const siteStatusData = {};
  const siteMigrationAdvertiseChecks = {};
  const siteIsdnRedirectCancelChecks = {};
  const siteIsdnRedirectTypeData = {};
  const siteIsdnRedirectNumberData = {};
  let isdnInDialBsipServiceMigrateAllCheck = false;
  let isdnInDialTiptServiceMigrateAllCheck = false;
  const sitesConfirmedList = [];
  const siteSipConnectPabxVendor = {};
  const siteSipConnectPabxModel = {};
  const siteSipConnectNumberOfTrunks = {};
  const siteSipContractMonthsData = {};

  const sitesDataToBeReloaded = sitesData.filter(siteData => siteData.siteStatus !== 'NOTSTARTED');

  sitesDataToBeReloaded.forEach((siteDataItems) => {
    siteStatusData[siteDataItems.siteId] = siteDataItems.siteStatus;
    if (siteDataItems.siteStatus === SITE_STATUS_SUBMITTED) {
      sitesConfirmedList.push(siteDataItems.siteId);
    }

    const formField = {
      siteId: siteDataItems.siteId,
      siteContactEmail: siteDataItems.usrSiteContactEmail,
      siteContactFirstName: siteDataItems.usrSiteContactFirstName,
      siteContactLastName: siteDataItems.usrSiteContactLastName,
      siteContactPhone: siteDataItems.usrSiteContactPhone,
      info: siteDataItems.usrAddSiteNotes,
    };
    siteFormFields = [...siteFormFields, formField];

    const formFieldErrors = {
      siteId: siteDataItems.siteId,
      siteContactEmail: { invalid: validateContactSiteFormFields('siteContactEmail', siteDataItems.usrSiteContactEmail),
        touched: siteDataItems.usrSiteContactEmail !== null },
      siteContactFirstName: { invalid: validateContactSiteFormFields('siteContactFirstName', siteDataItems.usrSiteContactFirstName),
        touched: siteDataItems.usrSiteContactFirstName !== null },
      siteContactLastName: { invalid: validateContactSiteFormFields('siteContactLastName', siteDataItems.usrSiteContactLastName),
        touched: siteDataItems.usrSiteContactLastName !== null },
      siteContactPhone: { invalid: validateContactSiteFormFields('siteContactPhone', siteDataItems.usrSiteContactPhone),
        touched: siteDataItems.usrSiteContactPhone !== null },
    };

    contactSiteFieldsHasErrors = [...contactSiteFieldsHasErrors, formFieldErrors];

    const goToOption = {
      siteId: siteDataItems.siteId,
      isdnGoTo: siteDataItems.goToOptions,
    };
    siteIsdnGoToOptions = [...siteIsdnGoToOptions, goToOption];

    let deliveryAddressesData = {};
    if (siteDataItems.usrSiteId !== undefined && siteDataItems.usrSiteId !== '' && siteDataItems.usrSiteId !== null) {
      deliveryAddressesData = {
        siteId: siteDataItems.siteId,
        fullAddress: `${siteDataItems.usrPropertyNum} ${siteDataItems.usrStName} 
          ${siteDataItems.usrStType} ${siteDataItems.usrSuburb}, ${siteDataItems.usrState}, ${siteDataItems.usrPostcode}`,
        modifiedDetailedAddresObject: {
          addressId: siteDataItems.usrSiteId,
          fullAddress: {
            propertyAddressDetails: {
              propertyNumberFrom: siteDataItems.usrPropertyNum,
              streetDetails: {
                streetName: siteDataItems.usrStName,
                streetType: siteDataItems.usrStType,
              },
            },
            localityDetails: {
              locality: siteDataItems.usrSuburb,
              state: siteDataItems.usrState,
              postCode: siteDataItems.usrPostcode,
            },
          },
        },
      };
    } else {
      deliveryAddressesData = {
        siteId: siteDataItems.siteId,
        fullAddress: siteDataItems.siteAddress,
        modifiedDetailedAddresObject: {},
      };
    }

    siteDeliveryAddressesData = [...siteDeliveryAddressesData, deliveryAddressesData];


    const phone = `${siteDataItems.siteId}-${PORT_TYPE_P_PHONE}`;
    const analog = `${siteDataItems.siteId}-${PORT_TYPE_ANALOG}`;
    const mobile = `${siteDataItems.siteId}-${PORT_TYPE_MOBILE}`;
    siteMigrationCounts[phone] = null;
    siteMigrationCounts[analog] = null;
    siteMigrationCounts[mobile] = null;

    if (siteDataItems.inDial === true) {
      siteDataItems.siteServiceDetails.forEach((serviceDetails) => {
        const migrateElementId = `${siteDataItems.siteId}-indial-${serviceDetails.dn}-migrate`;
        const cancelElementId = `${siteDataItems.siteId}-indial-${serviceDetails.dn}-cancel`;
        const redirectElementId = `${siteDataItems.siteId}-indial-${serviceDetails.dn}-redirect`;
        const redirectTypeElementId = `redirectType-${siteDataItems.siteId}-indial-${serviceDetails.dn}`;
        const redirectNumberElementId = `redirectNumber-${siteDataItems.siteId}-indial-${serviceDetails.dn}`;

        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT && serviceDetails.migrate) {
          siteIsdnInDialTiptServiceMigrateCancelCheckList[migrateElementId] = serviceDetails.migrate;
        } else if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT && serviceDetails.cancel) {
          siteIsdnInDialTiptServiceMigrateCancelCheckList[cancelElementId] = serviceDetails.cancel;
        }
        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT) {
          siteDataItems.inDialServices.forEach((item) => {
            siteIsdnInDialBsipServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
          });
          isdnInDialBsipServiceMigrateAllCheck = true;
        }
        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_SIP_CONNECT) {
          siteDataItems.inDialServices.forEach((item) => {
            siteIsdnInDialBsipServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
            siteIsdnInDialTiptServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
          });
          isdnInDialBsipServiceMigrateAllCheck = true;
          isdnInDialTiptServiceMigrateAllCheck = true;
        }

        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP && serviceDetails.migrateToBsip) {
          siteIsdnInDialBsipServiceMigrateCancelCheckList[migrateElementId] = serviceDetails.migrateToBsip;
        } else if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP && serviceDetails.cancel) {
          siteIsdnInDialBsipServiceMigrateCancelCheckList[cancelElementId] = serviceDetails.cancel;
        }
        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_BSIP) {
          siteDataItems.inDialServices.forEach((item) => {
            siteIsdnInDialTiptServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
          });
          isdnInDialTiptServiceMigrateAllCheck = true;
        }

        if (siteDataItems.goToOptions === ISDN_GOTOOPTION_REDIRECT_OR_CANCEL) {
          if (serviceDetails.redirect === true) {
            siteIsdnInDialServiceRedirectCancelCheckList[redirectElementId] = serviceDetails.redirect;
          } else {
            siteIsdnInDialServiceRedirectCancelCheckList[cancelElementId] = serviceDetails.cancel;
          }
          siteIsdnInDialRedirectTypeData[redirectTypeElementId] = serviceDetails.redirectType;
          siteIsdnInDialRedirectNumberData[redirectNumberElementId] = serviceDetails.redirectNumber;
        }
      });

      siteMigrationCounts[phone] = siteDataItems.numberOfPhoneUsers;
      siteMigrationCounts[analog] = siteDataItems.numberOfAnalogueDevices;
      siteMigrationCounts[mobile] = siteDataItems.numberOfLiberateMobileDevices;
      let phoneIndex = 0;
      let mobileIndex = 0;
      let analogIndex = 0;
      siteDataItems.indialNumberDetailing.forEach((indialNumberDetailing) => {
        if (indialNumberDetailing.intendedUse === 'Desk phone') {
          siteInDialUserNamesData[`${phone}-firstname-${phoneIndex + 1}`] = indialNumberDetailing.assignedFirstName;
          siteInDialUserNamesData[`${phone}-lastname-${phoneIndex + 1}`] = indialNumberDetailing.assignedLastName;
          siteInDialServiceNumberData[`${phone}-servicenumber-${phoneIndex + 1}`] = indialNumberDetailing.serviceNumber;
          siteInDialUserTypeData[`${phone}-usertype-${phoneIndex + 1}`] = indialNumberDetailing.userNumberType;
          phoneIndex += 1;
        } else if (indialNumberDetailing.intendedUse === 'Analog') {
          siteInDialUserNamesData[`${analog}-firstname-${analogIndex + 1}`] = indialNumberDetailing.assignedFirstName;
          siteInDialUserNamesData[`${analog}-lastname-${analogIndex + 1}`] = indialNumberDetailing.assignedLastName;
          siteInDialServiceNumberData[`${analog}-servicenumber-${analogIndex + 1}`] = indialNumberDetailing.serviceNumber;
          siteInDialUserTypeData[`${analog}-usertype-${analogIndex + 1}`] = indialNumberDetailing.userNumberType;
          analogIndex += 1;
        } else if (indialNumberDetailing.intendedUse === 'Liberate Mobile') {
          siteInDialUserNamesData[`${mobile}-firstname-${mobileIndex + 1}`] = indialNumberDetailing.assignedFirstName;
          siteInDialUserNamesData[`${mobile}-lastname-${mobileIndex + 1}`] = indialNumberDetailing.assignedLastName;
          siteInDialServiceNumberData[`${mobile}-servicenumber-${mobileIndex + 1}`] = indialNumberDetailing.serviceNumber;
          siteInDialUserTypeData[`${mobile}-usertype-${mobileIndex + 1}`] = indialNumberDetailing.userNumberType;
          mobileIndex += 1;
        }
      });
    } else { // end of indial if condition
      siteMigrationCounts[phone] = siteDataItems.numberOfPhoneUsers;
      siteMigrationCounts[analog] = siteDataItems.numberOfAnalogueDevices;
      siteMigrationCounts[mobile] = siteDataItems.numberOfLiberateMobileDevices;
      const serviceDetailsDnkeyArray = getsiteServiceDetailsArrayWithDNkey(siteDataItems.siteServiceDetails);

      if (siteDataItems.goToOptions === ISDN_GOTOOPTION_MIGRATE_ALL_TIPT) {
        siteDataItems.siteServices.forEach((parentService) => {
          siteMigrationAdvertiseChecks[`${siteDataItems.siteId}-${parentService.type}-${parentService.number}-checkbox`] =
          (serviceDetailsDnkeyArray[parentService.number].advertisedNumber) ? serviceDetailsDnkeyArray[parentService.number].advertisedNumber
            : false;

          if (parentService.primaryList && parentService.primaryList.length > 0) {
            parentService.primaryList.forEach((childService) => {
              siteMigrationAdvertiseChecks[`${siteDataItems.siteId}-PrimaryFNN-${childService.number}-checkbox`] =
                (serviceDetailsDnkeyArray[childService.number].advertisedNumber) ? serviceDetailsDnkeyArray[parentService.number].advertisedNumber
                  : false;

              childService.auxList.forEach((auxService) => {
                siteMigrationAdvertiseChecks[`${siteDataItems.siteId}-Auxillary-${auxService}-checkbox`] =
                  (serviceDetailsDnkeyArray[auxService].advertisedNumber) ? serviceDetailsDnkeyArray[auxService].advertisedNumber : false;
              });
            });
          } else {
            parentService.auxList.forEach((auxService) => {
              siteMigrationAdvertiseChecks[`${siteDataItems.siteId}-Auxillary-${auxService}-checkbox`] =
                (serviceDetailsDnkeyArray[auxService].advertisedNumber) ? serviceDetailsDnkeyArray[auxService].advertisedNumber : false;
            });
          }
        });
      } else if (siteDataItems.goToOptions === ISDN_GOTOOPTION_REDIRECT_OR_CANCEL) {
        siteDataItems.siteServices.forEach((parentService) => {
          siteIsdnRedirectCancelChecks[`redirect-${parentService.type}-${parentService.number}`] =
            serviceDetailsDnkeyArray[parentService.number].redirect;
          siteIsdnRedirectCancelChecks[`cancel-${parentService.type}-${parentService.number}`] =
            serviceDetailsDnkeyArray[parentService.number].cancel;
          siteIsdnRedirectTypeData[`redirectType-${parentService.type}-${parentService.number}`] =
            serviceDetailsDnkeyArray[parentService.number].redirectType;
          siteIsdnRedirectNumberData[`redirectNumber-${parentService.type}-${parentService.number}`] =
            serviceDetailsDnkeyArray[parentService.number].redirectNumber;

          if (parentService.primaryList && parentService.primaryList.length > 0) {
            parentService.primaryList.forEach((childService) => {
              if (serviceDetailsDnkeyArray[childService.number] !== undefined) {
                siteIsdnRedirectCancelChecks[`redirect-PrimaryFNN-${childService.number}`] = serviceDetailsDnkeyArray[childService.number].redirect;
                siteIsdnRedirectCancelChecks[`cancel-PrimaryFNN-${childService.number}`] = serviceDetailsDnkeyArray[childService.number].cancel;
                siteIsdnRedirectTypeData[`redirectType-PrimaryFNN-${childService.number}`] =
                  serviceDetailsDnkeyArray[childService.number].redirectType;
                siteIsdnRedirectNumberData[`redirectNumber-PrimaryFNN-${childService.number}`] =
                  serviceDetailsDnkeyArray[childService.number].redirectNumber;
              }
            });
          }
        });
      }
    }
    const ServiceTerm = {
      siteId: siteDataItems.siteId,
      connectionDate: null,
      purchaseRentalSelectedOption: siteDataItems.serviceTerm.tiptServiceChoice !== null && siteDataItems.serviceTerm.tiptServiceChoice.length < 1 ?
        SERVICE_TERM_PURCHASE_RADIO_BUTTON : siteDataItems.serviceTerm.tiptServiceChoice,
    };

    siteServiceTermConnectionDateData = [...siteServiceTermConnectionDateData, ServiceTerm];

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_POWERPACKS, 'PolycomPSVVX301', siteDataItems.siteId, siteDataItems.serviceTerm.powerPackQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_HEADSET, 'headsetJabra40', siteDataItems.siteId, siteDataItems.serviceTerm.headsetJabraQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_HEADSET, 'headsetPlantronics', siteDataItems.siteId, siteDataItems.serviceTerm.headsetPlantronicsQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'liberateMobilePack', siteDataItems.siteId, siteDataItems.serviceTerm.liberateMobilePackQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES, 'fxs2PortIAD', siteDataItems.siteId, siteDataItems.serviceTerm.iadTwoPortQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_INTEGRATEDACCESSDEVICES, 'fxs8PortIAD', siteDataItems.siteId, siteDataItems.serviceTerm.iadEightPortQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_CALLCENTER, 'mireception', siteDataItems.siteId, siteDataItems.serviceTerm.miReception));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_CALLCENTER, 'callcenteragentstandard', siteDataItems.siteId, siteDataItems.serviceTerm.callCentreAgentStandard));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_CALLCENTER, 'callcenteragentpremium', siteDataItems.siteId, siteDataItems.serviceTerm.callCentreAgentPremium));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
      'callcentersupervisorstandard', siteDataItems.siteId, siteDataItems.serviceTerm.callCentreSupervisorStandard));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
      'callcentersupervisorpremium', siteDataItems.siteId, siteDataItems.serviceTerm.callCentreSupervisorPremium));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(SERVICE_TERM_DEVICE_TYPE_CALLCENTER,
      'mireceptioncallcenteragentstandard', siteDataItems.siteId, siteDataItems.serviceTerm.miReceptionCallCentreAgentStandard));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'basicFeaturePack', siteDataItems.siteId, siteDataItems.serviceTerm.feauturePackBasicQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'standardFeaturePack', siteDataItems.siteId, siteDataItems.serviceTerm.feauturePackStandardQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'businessContinuity',
      siteDataItems.siteId, siteDataItems.serviceTermBSIP.businessContinuityQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'businessLine', siteDataItems.siteId, siteDataItems.serviceTermBSIP.businessLineQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(
      BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS, 'mobility', siteDataItems.siteId, siteDataItems.serviceTermBSIP.mobilityQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
      BUSINESS_CONTINUITY, siteDataItems.siteId, siteDataItems.serviceTermSIPConnect.sipConnectBusinessContinuityFeaturePackQuantity));

    siteServiceTermDeviceQuantityData.push(setDeviceQuantityData(BSIP_SERVICE_TERM_DEVICE_TYPE_FEATURESPACKS,
      MOBILITY_CONTINUITY, siteDataItems.siteId, siteDataItems.serviceTermSIPConnect.sipConnectMobilityFeaturePackQuantity));

    siteSitesBsipCallingPlanSelection[siteDataItems.siteId] = siteDataItems.serviceTermBSIP.callingPlan !== null
      && siteDataItems.serviceTermBSIP.callingPlan.trim().length > 0 ?
      siteDataItems.serviceTermBSIP.callingPlan.trim() : BSIP_CALLING_PLAN_SMALL;

    const contractTerm = siteDataItems.serviceTermBSIP.contractTerm !== null
      && siteDataItems.serviceTermBSIP.contractTerm.trim().length > 0 ?
      siteDataItems.serviceTermBSIP.contractTerm.trim() : '24';
    siteSitesBsipContractMonthsData[siteDataItems.siteId] = `${contractTerm} months`;

    if (siteDataItems.serviceTermSIPConnect.sipConnectContractTerm !== null && siteDataItems.serviceTermSIPConnect.sipConnectContractTerm !== '') {
      siteSipContractMonthsData[siteDataItems.siteId] = siteDataItems.serviceTermSIPConnect.sipConnectContractTerm.trim();
    } else {
      siteSipContractMonthsData[siteDataItems.siteId] = SIP_CONNECT_SERVICE_TERM_DEFAULT_CONTRACT_TERM;
    }

    const sipConnectPabxVendor = siteDataItems.serviceTermSIPConnect.pabxVendor !== null && siteDataItems.serviceTermSIPConnect.pabxVendor !== '' ?
      siteDataItems.serviceTermSIPConnect.pabxVendor : SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION;
    siteSipConnectPabxVendor[siteDataItems.siteId] = sipConnectPabxVendor;

    const sipConnectPabxModel = siteDataItems.serviceTermSIPConnect.pabxModel !== null && siteDataItems.serviceTermSIPConnect.pabxModel !== '' ?
      siteDataItems.serviceTermSIPConnect.pabxModel : SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION;
    siteSipConnectPabxModel[siteDataItems.siteId] = sipConnectPabxModel;

    const numberOfTrunks = siteDataItems.serviceTermSIPConnect.numberOfTrunks !== null &&
      siteDataItems.serviceTermSIPConnect.numberOfTrunks > 0 ?
      siteDataItems.serviceTermSIPConnect.numberOfTrunks : SIP_CALLING_PLAN_SELECT_OPTION;
    siteSipConnectNumberOfTrunks[siteDataItems.siteId] = numberOfTrunks;
  });

  const notStartedSitesData = sitesData.filter(siteData => siteData.siteStatus === 'NOTSTARTED');

  notStartedSitesData.forEach((siteDataItems) => {
    if (siteDataItems.goToOptions.trim() === ISDN_GOTOOPTION_YET_TO_FILL_IN_DETAILS) {
      siteDataItems.inDialServices.forEach((item) => {
        siteIsdnInDialBsipServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
        siteIsdnInDialTiptServiceMigrateCancelCheckList[`${siteDataItems.siteId}-indial-${item.serviceNumber}-migrate`] = true;
      });
    }
  });

  const notStartedFormFields = prepareContactSitesDataOnApplicationLoad(notStartedSitesData);
  const notStartedFormFieldsErrors = prepareErrorMessageDataForContactSiteOnApplicatioLoad(notStartedSitesData);

  const notStartedBsipContractMonthsData = prepareSitesBsipContractMonthsSelection(notStartedSitesData);
  const notStartedBsipCallingPlanSelection = prepareSitesBsipCallingPlan(notStartedSitesData);

  const notStartedGoToOptions = prepareIsdnGoToOptionsSelections(notStartedSitesData);

  const notStartedServiceTermDeviceQuantityData = prepareServiceTermDevicesQuantityDataForSitesOnApplicationLoad(notStartedSitesData,
    authorableContent.serviceTerm);

  const notStartedServiceTermConnectionDateData = prepareServiceTermConnectionDateForSitesOnApplicationLoad(notStartedSitesData);

  const notStartedDeliveryAddressData = prepareDeliveryAddressForSitesOnApplicationLoad(notStartedSitesData);

  const notStartedSIPConnectContractMonthsData = prepareSitesSipConnectContractMonthsSelection(notStartedSitesData);

  notStartedSitesData.forEach((site) => {
    siteStatusData[site.siteId] = 'NOTSTARTED';
  });

  reLoadingData = {
    formFields: [...siteFormFields, ...notStartedFormFields],
    isdnGoToOptions: [...siteIsdnGoToOptions, ...notStartedGoToOptions],
    migrationCounts: siteMigrationCounts,
    migrationAdvertiseChecks: siteMigrationAdvertiseChecks,
    inDialUserNamesData: siteInDialUserNamesData,
    inDialServiceNumberData: siteInDialServiceNumberData,
    inDialUserTypeData: siteInDialUserTypeData,
    isdnInDialTiptServiceMigrateCancelCheckList: siteIsdnInDialTiptServiceMigrateCancelCheckList,
    isdnInDialBsipServiceMigrateCancelCheckList: siteIsdnInDialBsipServiceMigrateCancelCheckList,
    isdnInDialServiceRedirectCancelCheckList: siteIsdnInDialServiceRedirectCancelCheckList,
    isdnInDialRedirectTypeData: siteIsdnInDialRedirectTypeData,
    isdnInDialRedirectNumberData: siteIsdnInDialRedirectNumberData,
    isdnRedirectCancelChecks: siteIsdnRedirectCancelChecks,
    isdnRedirectNumberData: siteIsdnRedirectNumberData,
    isdnRedirectTypeData: siteIsdnRedirectTypeData,
    serviceTermConnectionDateData: [...siteServiceTermConnectionDateData, ...notStartedServiceTermConnectionDateData],
    serviceTermDeviceQuantityData: [...siteServiceTermDeviceQuantityData, ...notStartedServiceTermDeviceQuantityData],
    sitesBsipCallingPlanSelection: { ...siteSitesBsipCallingPlanSelection, ...notStartedBsipCallingPlanSelection },
    sitesBsipContractMonthsData: { ...siteSitesBsipContractMonthsData, ...notStartedBsipContractMonthsData },
    isdnInDialBsipServiceMigrateAllCheck,
    isdnInDialTiptServiceMigrateAllCheck,
    contactSiteFieldsHasErrors: [...contactSiteFieldsHasErrors, ...notStartedFormFieldsErrors],
    siteStatusData,
    sitesConfirmedList,
    deliveryAddressesData: [...siteDeliveryAddressesData, ...notStartedDeliveryAddressData],
    sitesSipContractMonthsData: { ...siteSipContractMonthsData, ...notStartedSIPConnectContractMonthsData },
    sitesSipConnectPabxVendor: siteSipConnectPabxVendor,
    sitesSipConnectPabxModel: siteSipConnectPabxModel,
    sitesSipConnectNumberOfTrunks: siteSipConnectNumberOfTrunks,
  };
  return reLoadingData;
};

export const validateInDialNumerDetailingTable = (siteId, migrationCounts, inDialServiceNumberData) => {
  const pPhoneValue = migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_P_PHONE}`] : 0;
  const analogValue = migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_ANALOG}`] : 0;
  const mobileValue = migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== undefined && migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] !== '' ?
    migrationCounts[`${siteId}-${PORT_TYPE_MOBILE}`] : 0;

  const totalCount = parseInt(pPhoneValue, 10) + parseInt(analogValue, 10) + parseInt(mobileValue, 10);

  const entriesCount = Object.keys(inDialServiceNumberData).length;

  return totalCount <= entriesCount;
};

export const validateSipNetWorkConnectionDevice = (siteId, sitesSipConnectPabxVendor, sitesSipConnectPabxModel) => {
  /** check net work Connection device drop down value */
  if (sitesSipConnectPabxVendor[siteId] === undefined || (sitesSipConnectPabxVendor[siteId] !== undefined &&
    sitesSipConnectPabxVendor[siteId] === SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)) {
    return false;
  } else if (isVendorSelected(sitesSipConnectPabxVendor[siteId]) && (
    sitesSipConnectPabxModel[siteId] === undefined || sitesSipConnectPabxModel[siteId] === SIP_CONNECT_NETWORK_DEVICE_SELECT_OPTION)) {
    return false;
  }
  return true;
};

export const validateSipCallingPlan = (siteId, sitesSipConnectNumberOfTrunks) => {
  if (sitesSipConnectNumberOfTrunks[siteId] === undefined || sitesSipConnectNumberOfTrunks[siteId] === SIP_CALLING_PLAN_SELECT_OPTION) {
    return false;
  }
  return true;
};

export const validateSipConnect = (siteId, sitesSipConnectPabxVendor, sitesSipConnectPabxModel, sitesSipConnectNumberOfTrunks, inDial,
  iSDN2, sipConnectServiceTermData) => {
  let sipCallingPlan = true;
  let sipNetWorkConnectionDevice = true;
  let sipConnectServiceTerm = true;

  /** validate network Connection device drop down value */
  sipNetWorkConnectionDevice = validateSipNetWorkConnectionDevice(siteId, sitesSipConnectPabxVendor, sitesSipConnectPabxModel);

  /** validate calling plan drop down */
  sipCallingPlan = validateSipCallingPlan(siteId, sitesSipConnectNumberOfTrunks, inDial, iSDN2, sitesSipConnectPabxVendor, sitesSipConnectPabxModel);
  /** validate service drop down */
  if (sipConnectServiceTermData.sitesSipContractMonthsData === undefined || (sipConnectServiceTermData.sitesSipContractMonthsData[siteId] ===
    undefined || sipConnectServiceTermData.sitesSipContractMonthsData[siteId] === sipConnectServiceTermData.contractTerm.placeholder)) {
    sipConnectServiceTerm = false;
  }

  return sipCallingPlan && sipNetWorkConnectionDevice && sipConnectServiceTerm;
};

export const setDropDownValue = (options, key) => {
  const keyValue = options.filter(option => option.key === key);
  return (keyValue !== undefined && keyValue[0] !== undefined) ? keyValue[0].value : options[0].value;
};

export const prepareSitesEnterpriseTrunkOptions = (enterpriseTrunkingNumbers) => {
  const options = enterpriseTrunkingNumbers.map((item) => {
    let optionData = {};
    optionData = { key: item, value: (item === 'REQUEST_CALL_BACK') ? REQUEST_CALL_BACK : item };
    return optionData;
  });
  return options;
};

export const prepareSitesSIPInDialMigrateToEnterpriseTrunk = (sitesData) => {
  const migrateToEnterpriseTrunk = {};
  const migrateToEnterpriseTrunkSelection = {};
  const enterpriseTrunkOptions = [];
  const enterpriseTrunkValidationTracking = {};
  sitesData.forEach((siteData) => {
    /** prepare migrateToEnterpriseTrunk is true or false  */
    migrateToEnterpriseTrunk[`${siteData.siteId}-${MIGRATE_TO_ENTERPRISE_TRUNK}`] = siteData.migrateToEnterpriseTrunk;
    enterpriseTrunkValidationTracking[siteData.siteId] = false;

    /** prepare enterprise selection data according to service number */
    if (siteData.inDialServices !== undefined && siteData.inDialServices.length > 0 && siteData.inDial) {
      siteData.inDialServices.map((item) => {
        migrateToEnterpriseTrunkSelection[`${siteData.siteId}-${item.serviceNumber}`]
          = item.enterpriseTrunkSelected !== null ? item.enterpriseTrunkSelected : '';
        return migrateToEnterpriseTrunkSelection;
      });
    } if (siteData.siteServices !== undefined && siteData.siteServices.length > 0 && siteData.inDial === false) {
      siteData.siteServices.forEach((parentService) => {
        migrateToEnterpriseTrunkSelection[`${siteData.siteId}-${parentService.number}`] =
          parentService.enterpriseTrunkSelected !== null ? parentService.enterpriseTrunkSelected : '';
        if (parentService.primaryList && parentService.primaryList.length > 0) {
          parentService.primaryList.forEach((childService) => {
            migrateToEnterpriseTrunkSelection[`${siteData.siteId}-${childService.number}`] =
              childService.enterpriseTrunkSelected !== null ? childService.enterpriseTrunkSelected : '';
          });
        }
      });
    }
    /** prepare enterprise selection option  */
    enterpriseTrunkOptions[siteData.siteId] = (siteData.enterpriseTrunkingNumbers !== undefined && siteData.enterpriseTrunkingNumbers.length > 0) ?
      prepareSitesEnterpriseTrunkOptions(siteData.enterpriseTrunkingNumbers) : [];
  });

  const enterpriseTrunkData = {
    sitesSIPInDialMigrateToEnterpriseTrunk: migrateToEnterpriseTrunk,
    sitesSIPInDialMigrateToEnterpriseTrunkSelection: migrateToEnterpriseTrunkSelection,
    sitesEnterpriseTrunkOptions: enterpriseTrunkOptions,
    sitesEnterpriseTrunkValidationTracking: enterpriseTrunkValidationTracking,
  };
  return enterpriseTrunkData;
};

export const validateSipConnectEnterpriseTrunk = (siteID, inDial, migrateToEnterpriseTrunkSelection, servicesNumbers) => {
  let valid = true;
  if (servicesNumbers !== undefined && servicesNumbers.length > 0 && inDial) {
    servicesNumbers.forEach((item) => {
      const selectedValue = migrateToEnterpriseTrunkSelection[`${siteID}-${item.serviceNumber}`];
      valid = (selectedValue !== undefined && selectedValue !== '' && selectedValue && valid);
    });
  } if (servicesNumbers !== undefined && servicesNumbers.length > 0 && inDial === false) {
    servicesNumbers.forEach((parentService) => {
      let selectedValue = migrateToEnterpriseTrunkSelection[`${siteID}-${parentService.number}`];
      valid = (selectedValue !== undefined && selectedValue !== '' && selectedValue && valid);
      if (parentService.primaryList && parentService.primaryList.length > 0 && valid) {
        parentService.primaryList.forEach((childService) => {
          selectedValue = migrateToEnterpriseTrunkSelection[`${siteID}-${childService.number}`];
          valid = (selectedValue !== undefined && selectedValue !== '' && selectedValue && valid);
        });
      }
    });
  }
  return valid;
};
